
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _4040t2rYAnSkd8kYnodTPSbPcA6Q8AhTcYAZVNhIAW6D78Meta } from "/app/pages/404.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as PanduanibrljgmfuoaEYzwESlEDTGESXG4W5KNwzhCVg_45zvcGYMeta } from "/app/pages/Panduan.vue?macro=true";
import { default as indexngVHCtFeipGHfdVKkklVE8wVlAAHMrK8c3TZK_Z2H70Meta } from "/app/pages/old/index.vue?macro=true";
import { default as indexNaBQKILH2vMZ15A_457uJEdT0ZBnrL_45gEca5BJK8xNLhcMeta } from "/app/pages/pim/index.vue?macro=true";
import { default as DasarHukum5XiJvsSFbURQm3xoE3xSCwP5yUP_45tWMDQijGwtf9vw4Meta } from "/app/pages/DasarHukum.vue?macro=true";
import { default as TanyaJawab2s_teYsq4BK81SrUGbiAcnKRmlU5JmidLhxVtFkLZn0Meta } from "/app/pages/TanyaJawab.vue?macro=true";
import { default as indexb9seqUe3qTRAI7X64q30k1tfLhRw4FvFeKjYBzfUZIoMeta } from "/app/pages/revamp/index.vue?macro=true";
import { default as indexXkMRrAp57y2xt3_4510tXgeJiGLZZumpOxcqGHvOtz9x4Meta } from "/app/pages/revamp/login/index.vue?macro=true";
import { default as loginvc5VSS5bLd6731xzv8GjlrG6G9M_45cXEzLXkRBDoBz_45wMeta } from "/app/pages/revamp/login.vue?macro=true";
import { default as indexXnPtrZQjeC06z7sB7oCqUQ870jdk7SHcJllUl_45NmiDwMeta } from "/app/pages/survei/index.vue?macro=true";
import { default as pusat_45bantuanTdQpsWje5Tn6Qqd5qIdazUrzAGtcgYatIc8ZZAy26GgMeta } from "/app/pages/pusat-bantuan.vue?macro=true";
import { default as resetPasswordKEa0_45BGlUl46ZGppenCOrRFigbkL0R5K5qoJs7bf9xMMeta } from "/app/pages/resetPassword.vue?macro=true";
import { default as indexejFYWxyE8gEmNUI4t7m3X2fh8jmy6FKrpEepi9w4MXUMeta } from "/app/pages/ekosistem/index.vue?macro=true";
import { default as forgot_password_3VXyAHzsngPqArTw2_45YmgiEti824esiDhKAYVN5OusMeta } from "/app/pages/forgot_password.vue?macro=true";
import { default as templatea707nFXXNGF24UumXXLX8H7uuwiCWaLij2DDI_45QQSg4Meta } from "/app/pages/revamp/template.vue?macro=true";
import { default as indexxT0jzZUADHsm578rQZIcRDvLl6eGoHXFzgh3LYsBop0Meta } from "/app/pages/pim/[role]/index.vue?macro=true";
import { default as indexi_nOZdqbNlRaCVtHRmYqVcZWyks0MrP_tUUY7tEQhz8Meta } from "/app/pages/pim/Mentor/index.vue?macro=true";
import { default as indexoLLUpNvQeX9GqxwOh5TWLz0XebKOPM2v6WbB7k2_45yv4Meta } from "/app/pages/revamp/vpl/index.vue?macro=true";
import { default as RiwayatPelatihanWz2LTCPF7R5vhrmB_mMWrL0hq6yWMPXPHWnwSqH7RB0Meta } from "/app/pages/RiwayatPelatihan.vue?macro=true";
import { default as indexaGQBX41dZRwcZqeZq9bN4rEOhix7kYinxBstFsxgKSoMeta } from "/app/pages/maintenance/index.vue?macro=true";
import { default as indexITVvCZrSAy2mHLHGl03wK5VIkJG_ljeE8JJ7d39NSWUMeta } from "/app/pages/pim/Penguji/index.vue?macro=true";
import { default as indexizejv72Do1VnbAOu_Ptqsq_6mV1ap1sMjbwWjq5DuLEMeta } from "/app/pages/pim/Peserta/index.vue?macro=true";
import { default as indexwDwMwv3qrvyK9pP5bmfFNR0CJQtcdhhgfqulsRSZLxcMeta } from "/app/pages/profil-saya/index.vue?macro=true";
import { default as _91slug_9387uEdd_45u7a8wkpKWwiLtFAYxzLze4awVYaar8B7UxTQMeta } from "/app/pages/revamp/vpl/[slug].vue?macro=true";
import { default as privacy_45policyjPgub6XwurMWRtLnePoZnKa_457GNsZsg6XEptXqarCVwMeta } from "/app/pages/app/privacy-policy.vue?macro=true";
import { default as indexOFd7rlAubZwAlMtzyq55o9uTUmdRm7dP0cnct3mKfOkMeta } from "/app/pages/pim/Pengajar/index.vue?macro=true";
import { default as index_YDWXjFPm2qk1K58pcU4qA8iC4K7yWFwN4iZvT6pSVwsMeta } from "/app/pages/pim/Peserta/index_.vue?macro=true";
import { default as formbantuanhOpS6cG_45USTIGbDnVTwnpizMEz_leFkgYodSnUSrCiMMeta } from "/app/pages/revamp/formbantuan.vue?macro=true";
import { default as maintenanceXbp8Z2uAcILODhr_45TNJJ_lSNT0Qc3VrmeOA3M0KiX2UMeta } from "/app/pages/revamp/maintenance.vue?macro=true";
import { default as AbsensiHmKme4ammXvpDere_45Vg8_ZWqMRStRCnpxi9WZvkl0SUMeta } from "/app/pages/pim/Peserta/Absensi.vue?macro=true";
import { default as pusatbantuanLd2m3EyoOE57HdTGfmqzH3lM0MbyJEmoREP3Q46909wMeta } from "/app/pages/revamp/pusatbantuan.vue?macro=true";
import { default as index5TsQCLch5Z0VdGidGosLy2detaE2X6qrkoMzKnWJb1oMeta } from "/app/pages/revamp/survei/index.vue?macro=true";
import { default as indexLz7Qr5QLUx6Klr3cftEXnpIhNrExmoODGO6XITjEEgAMeta } from "/app/pages/pim/Pembimbing/index.vue?macro=true";
import { default as unduh_45panduanJSplwUySp1UYTsZP1wG4ScQBpjPBibJocYe1oVPT4wIMeta } from "/app/pages/revamp/unduh-panduan.vue?macro=true";
import { default as DataMentorwwLs9vrwUtHcAWFf8U5IJUbv_12wP8KkS_k1KQcCol0Meta } from "/app/pages/pim/[role]/DataMentor.vue?macro=true";
import { default as ubah_45fotoKeqScyvgGLvhUE_nuzKs0c3_45i_45hY0CE4Jk7kjXMl6UYMeta } from "/app/pages/profil-saya/ubah-foto.vue?macro=true";
import { default as DataPenguji1YBAMYHda9anwQAQdgS52ycLtVSO4hiUFNwoBdfmC5oMeta } from "/app/pages/pim/[role]/DataPenguji.vue?macro=true";
import { default as DataPesertazej8UZqjXPUIcwdVBESsvR_38vGwYsYpM8Fr2EXVzvMMeta } from "/app/pages/pim/[role]/DataPeserta.vue?macro=true";
import { default as DataPengajar6ci26ueZMU3CUQUa7eOMkC8M3oQYhEt56euftnGv32UMeta } from "/app/pages/pim/[role]/DataPengajar.vue?macro=true";
import { default as ubah_45kontakthDAhPT9WobNTJHKoQeAhGcAq03tTS7FALZhVl1Uns8Meta } from "/app/pages/profil-saya/ubah-kontak.vue?macro=true";
import { default as indexW_IyyZEc4SLwe2w3FRPkhW6IeMvcNNhSsdowEtYwo6cMeta } from "/app/pages/pembelajaran-wajib/index.vue?macro=true";
import { default as loginHOv7xG2MoUbFBWh5aQpIxz_458qziDjyGfkKnhJnc4GVQMeta } from "/app/pages/pembelajaran-wajib/login.vue?macro=true";
import { default as indexAr6LJa8g4bCaiU4tHHFVsa3xtakJyfq14k2pzdfbJEsMeta } from "/app/pages/revamp/profil-saya/index.vue?macro=true";
import { default as DataPembimbingfLj83Fk_0Xc7q_45dyzzbyy54yU4JBDssp2BXlQVDKO_45YMeta } from "/app/pages/pim/[role]/DataPembimbing.vue?macro=true";
import { default as indexaxKDSO7EbrMosdxvHCtD__45w9OQEBA0DSVQpw0YyiGVsMeta } from "/app/pages/portal-pembelajaran/index.vue?macro=true";
import { default as indexsiwABq4QphOa_CrDatwbzZgaTyWWnPNE3cWeGWKSfhgMeta } from "/app/pages/pembelajaran-mandiri/index.vue?macro=true";
import { default as indexvyZ_454W3kCPciYhAprW8AVCMAnozHi0reFp8cs4INj_45YMeta } from "/app/pages/pim/[role]/Pelatihan/index.vue?macro=true";
import { default as indexqc0UHZ6cvfr6NOuN0Xq9eO4IDy7qHdwUQvwzvE7Bt_45YMeta } from "/app/pages/pim/[role]/Referensi/index.vue?macro=true";
import { default as indexgdctXckBWJ_45j6_45qE1RKwp6G7o4bYWMwA5uIvN9Kqo4YMeta } from "/app/pages/pim/Mentor/Elearning/index.vue?macro=true";
import { default as MulaiPelatihanaBz9GTUi_45co7N2dvqWfl_458Dcl_45fzKUZRxLbFnMFyIq0Meta } from "/app/pages/pim/Peserta/MulaiPelatihan.vue?macro=true";
import { default as indexvM__456Sio2w9KQAQsKlusZorr6Wu8PrwWmJGar4j1SXkMeta } from "/app/pages/revamp/pusat-bantuan/index.vue?macro=true";
import { default as indexV8PylZ8P3TYc7nRNkpXD2_45R5LHNHM7l8FXdFG1zcll0Meta } from "/app/pages/pim/Penguji/Elearning/index.vue?macro=true";
import { default as indexAwNQoAn5noz7kf8kSAHGyBnGUxs4S_45I_vlcn_RnWmoIMeta } from "/app/pages/pim/Peserta/Elearning/index.vue?macro=true";
import { default as index36ZoqiEo4lqs_45v27J5vXaINP7JNUNYl_uz1E2GbzgbMMeta } from "/app/pages/pembelajaran-ekosistem/index.vue?macro=true";
import { default as indext4TW3MydbVfhQ9D2ENhzFC2SOXgXBJmyAJmxQ0m2F7MMeta } from "/app/pages/pim/Pengajar/Elearning/index.vue?macro=true";
import { default as ubah_45fotoYVCstUppCfcS9omA4g03jC8pgPWY56WrT1G_RxHSrWQMeta } from "/app/pages/revamp/profil-saya/ubah-foto.vue?macro=true";
import { default as _91id_93vFqKc0s5gt2legiHoshL_45M7nMcj1MOtcvUyf_45nBcOKMMeta } from "/app/pages/pim/Peserta/SelfLearning/[id].vue?macro=true";
import { default as dashboardEaAQL2Ay7fT5J_GexCUv81DNLOgkZBUQo7UUERuZzMQMeta } from "/app/pages/pembelajaran-mandiri/dashboard.vue?macro=true";
import { default as indexKef5O6xEF_mypZQpienmrTQZFRCPeNJsTkYTacb8pf4Meta } from "/app/pages/pim/[role]/Administrator/index.vue?macro=true";
import { default as MulaiKuisrfOoahbl3cvwVNjGfzbdrFqgZC0OjCQj8bQDEGahOhYMeta } from "/app/pages/pim/Mentor/component/MulaiKuis.vue?macro=true";
import { default as indexXNcWat6Jx7gR195Gk68kVWE7R6dC8g_45DfLJux_450ZuhQMeta } from "/app/pages/pim/Pembimbing/Elearning/index.vue?macro=true";
import { default as indexP6aClL7eA_45JECxbxeFqKrFRIqK0n5iF_GaaCckAe1_45YMeta } from "/app/pages/pim/Peserta/SelfLearning/index.vue?macro=true";
import { default as ubah_45kontakZ7HK1xBjDL_iQ3SQgVNUUxR7_45uyWGkBVzILXVuqOmCgMeta } from "/app/pages/revamp/profil-saya/ubah-kontak.vue?macro=true";
import { default as indexVxxipsIAL7mRqLJR8HKtaImdmB1lLb1cRoBOM7Q_4562YMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/index.vue?macro=true";
import { default as BukuManualRyv8RO5S1PvTQKB_AVRimVdETOcqXqXGaSQXoALC9U8Meta } from "/app/pages/pim/[role]/Referensi/BukuManual.vue?macro=true";
import { default as MulaiKuisc665utClt4l9ta9X1708BFjm1ZiCSNmhtmQeM7echXcMeta } from "/app/pages/pim/Penguji/component/MulaiKuis.vue?macro=true";
import { default as Agenda_45PembelajaranAWkjwjc4ZiEVQoJlHvgXG0u_45BRrn6LnKsdAZuWaoZMEMeta } from "/app/pages/pim/Peserta/Agenda-Pembelajaran.vue?macro=true";
import { default as MulaiKuissFCAsdcxt_Zge0GG9ubLFBV5Mp8J8_45WL1gub2YmzWdUMeta } from "/app/pages/pim/Peserta/component/MulaiKuis.vue?macro=true";
import { default as DataPICKKerYdaqDCCeTty_45s4yB531VpinT3gwcH4cje5f7ygQMeta } from "/app/pages/pim/[role]/Administrator/DataPIC.vue?macro=true";
import { default as _91id_93xRmqnovWGh2QmETm8MqMOPPSig6_kXdMCOI40loesQMMeta } from "/app/pages/pim/[role]/Referensi/Materi/[id].vue?macro=true";
import { default as PolicyPaper1Iq7TBSsWbxKfuaBVYu5CwnBK3Z_45ubdtjRvJNg9cGuEMeta } from "/app/pages/pim/[role]/Referensi/PolicyPaper.vue?macro=true";
import { default as MulaiKuis1EprxsflcdijCDmYNP7kA3CAzyeZeympg5za_G1FJKsMeta } from "/app/pages/pim/Pengajar/component/MulaiKuis.vue?macro=true";
import { default as indexTbzIuiIvJ8t4uPtI2_sETp7KwYIAD8rC8W_459xhIAzrcMeta } from "/app/pages/revamp/portal-pembelajaran/index.vue?macro=true";
import { default as formbantuandhOV_45npVO5KWXWGGwovK7kvCXXnLU_45A4tUUhABq3sBoMeta } from "/app/pages/revamp/pusat-bantuan/formbantuan.vue?macro=true";
import { default as indexoEcVeUrUFhD4AyzAmXYmuGf_R8qjs5tFOS98f_45TCKewMeta } from "/app/pages/pembelajaran-mandiri/[slug]/index.vue?macro=true";
import { default as quizvGX18oARwER76PR8LEUyPdETb4G4QgE5zxEyd8qLF08Meta } from "/app/pages/pembelajaran-wajib/terjadwal/quiz.vue?macro=true";
import { default as index7ScPF8qbu6SHtSiQdVObihvelVBsxxUeV8eH6BiDUsoMeta } from "/app/pages/pim/[role]/Referensi/Materi/index.vue?macro=true";
import { default as SelfLearning_45dYO_GhvxB28ny09J_3vqHOVVv5AThTib1fYpb9U3ZIMeta } from "/app/pages/pim/Mentor/component/SelfLearning.vue?macro=true";
import { default as TotalAbsensiOH7Pt4ZiukgpBFj3ZbLo6zPVek_nTft0PHGKIevfEggMeta } from "/app/pages/pim/Mentor/component/TotalAbsensi.vue?macro=true";
import { default as PolicyBriefM5FYao6fTM3_45GiUkXbN9KE9J6IoaQfQ_q7_45NTbkWA9cMeta } from "/app/pages/pim/Peserta/Elearning/PolicyBrief.vue?macro=true";
import { default as lessonncPnve3P0Litw0GFVW6lgA1eZB_45pxfiv4m22Mcb6sYwMeta } from "/app/pages/pembelajaran-mandiri/[slug]/lesson.vue?macro=true";
import { default as index_2ciT6PO9SH4azQq94NquOeoiwxha3mACYUUMEhapgUMeta } from "/app/pages/pembelajaran-wajib/terjadwal/index.vue?macro=true";
import { default as JadwalPenting8n3T_45mk4_TbjcbcP8_45xHD5dftCDS2y7EZKY1HxXV648Meta } from "/app/pages/pim/[role]/Referensi/JadwalPenting.vue?macro=true";
import { default as StudiLapangan6ej_45OQOsk3L7G4b6rdSPfKvfsy07Nx9hTGK_45SW0ZX_EMeta } from "/app/pages/pim/[role]/Referensi/StudiLapangan.vue?macro=true";
import { default as MulaiKuis4AOoLpZoB0p0SswQLR691cW3hLTvK3_45rrsC45p4br28Meta } from "/app/pages/pim/Pembimbing/component/MulaiKuis.vue?macro=true";
import { default as SelfLearningmeVrOIBEnjVWNxG9r7ntcdkjHoqc3dFs04NIwpZTIZkMeta } from "/app/pages/pim/Penguji/component/SelfLearning.vue?macro=true";
import { default as TotalAbsensiSyzDTigiv4uKbbYvaYaKK067WUUJPECcRUFbNzGvLxsMeta } from "/app/pages/pim/Penguji/component/TotalAbsensi.vue?macro=true";
import { default as SelfLearning_NLlKtQ_g_nZX_45SUmBk_45_45djB7uJhidhHv9jgwHVDpyEMeta } from "/app/pages/pim/Peserta/component/SelfLearning.vue?macro=true";
import { default as TotalAbsensiveIssuC3NyGrzHTPUWT4Hmc_451sCTQ32lZyOQtfroayYMeta } from "/app/pages/pim/Peserta/component/TotalAbsensi.vue?macro=true";
import { default as indexUSGsQT8LU0xxnOvEaNObm_taWL_BryJAM063y_45UVYoUMeta } from "/app/pages/pembelajaran-ekosistem/[slug]/index.vue?macro=true";
import { default as agendaSpiw9VotTKzb2pIlzSqR5OWBdkSE854l_UinrdI7OgsMeta } from "/app/pages/pembelajaran-wajib/terjadwal/agenda.vue?macro=true";
import { default as profil7YkVYOy87hXT5wG7TQgxeKENTursiInNDF9M8NsIW_45QMeta } from "/app/pages/pembelajaran-wajib/terjadwal/profil.vue?macro=true";
import { default as PelatihanrVkyG_fqfd_a0qH6q3W_73R0NcSLy9_L6hhHyCITvMsMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/Pelatihan.vue?macro=true";
import { default as TatapMaya4_m7f_mAkr6HoiVoA_45vUGItf3cLI_45cEkjUfnxVWUtKEMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/TatapMaya.vue?macro=true";
import { default as BobotPenilaian_45BThKlXvhTe1G1FbjNtwqdb_45Te0q6z_45eaLA3eZDwNMwMeta } from "/app/pages/pim/[role]/Referensi/BobotPenilaian.vue?macro=true";
import { default as VisitasiAgendaRigu2aDpclOscPC1LFLcZLoSxHebHCCflp6NHx6iEMwMeta } from "/app/pages/pim/[role]/Referensi/VisitasiAgenda.vue?macro=true";
import { default as MaterPelatihanTNo1wtSWOENhSsyvzPyEkoWVUDE8LtHsBfonYRwK94gMeta } from "/app/pages/pim/Mentor/component/MaterPelatihan.vue?macro=true";
import { default as VideoPelatihanDHKpmbbPpO1yZLAIre5aRmgtm_45v8LZvZ_CpxMaQ4EwEMeta } from "/app/pages/pim/Mentor/component/VideoPelatihan.vue?macro=true";
import { default as SelfLearningnCzzF831O6M6BNb0XKRYolQQmmika8cNWnU86ed2QwoMeta } from "/app/pages/pim/Pengajar/component/SelfLearning.vue?macro=true";
import { default as TotalAbsensi9tuPTsJ_FKtzAtIe9qNocxAsw0wrEMUVCnGA2k_451mjgMeta } from "/app/pages/pim/Pengajar/component/TotalAbsensi.vue?macro=true";
import { default as AksiPerubahanAHS6F_45RNJ_FpBBbHY33AF1XNcgCKsE907KAVP4CqQPUMeta } from "/app/pages/pim/Peserta/Elearning/AksiPerubahan.vue?macro=true";
import { default as StudyLapanganyv3TqPH_45lQu6srcubjcJlmK_45Yt0xs3a5sHd3OhI8L58Meta } from "/app/pages/pim/Peserta/Elearning/StudyLapangan.vue?macro=true";
import { default as DataPelatihanr23NuhZujyDsfVIQuwDSXEXDheVnSOdNQj6twto3iuYMeta } from "/app/pages/pim/Peserta/Pelatihan/DataPelatihan.vue?macro=true";
import { default as index9S7kYMVISnUR2TCCTXoEgI2DhCl42CjKl_45qdo0oRCxAMeta } from "/app/pages/revamp/pusat-bantuan/helpdesk/index.vue?macro=true";
import { default as PertanyaanUjian93QSomSH9tWpPJxOifYs9m49vPf6rmKjQTrKgruf1KgMeta } from "/app/pages/pim/[role]/Referensi/PertanyaanUjian.vue?macro=true";
import { default as ProyekPerubahan6dgEpC0FOy_Kt_hrxtLI3HQP3uA3pHbE_UPVEgH3iOIMeta } from "/app/pages/pim/[role]/Referensi/ProyekPerubahan.vue?macro=true";
import { default as DetailElearning85wdb3NgcKkNX90E4MutJ06OJ_45uWqW6AaWTy3AY_Dl0Meta } from "/app/pages/pim/Mentor/component/DetailElearning.vue?macro=true";
import { default as MaterPelatihanrOzGfovwMBWkhgL49PEV8167EmIF5MTOo166nk3vGUIMeta } from "/app/pages/pim/Penguji/component/MaterPelatihan.vue?macro=true";
import { default as VideoPelatihan9oVs9ln7Y3BFEptb_45D4QmqfyK4oEpIDrvbfBdRe_452nQMeta } from "/app/pages/pim/Penguji/component/VideoPelatihan.vue?macro=true";
import { default as MaterPelatihanuI8r1weFIgqJE_CqZdTLs4Pc5Pmxki_456Ld4hjZqdwLQMeta } from "/app/pages/pim/Peserta/component/MaterPelatihan.vue?macro=true";
import { default as VideoPelatihannoaIdiqEM7tyTvFJbIZNVoJP6IkfvJwmDcOPCkUQhcsMeta } from "/app/pages/pim/Peserta/component/VideoPelatihan.vue?macro=true";
import { default as VisitasiAgendaDkb_45ZQcB_45Bj4iUxI4gwOBe9JFWR3oT5zo7Tu2NF90G8Meta } from "/app/pages/pim/Peserta/Elearning/VisitasiAgenda.vue?macro=true";
import { default as indexjgox8p_45sCRdFHXYs14ZEPf_7sh0KZmdtIwkFy3w591sMeta } from "/app/pages/pembelajaran-wajib/terintegrasi/index.vue?macro=true";
import { default as PolicyBriefMtFkrF9JK3VE_45P1_2a4BleF654No9qRuu0taLelwSSQMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/PolicyBrief.vue?macro=true";
import { default as StakeHoldercbzFEnP_45RR_45sn8B0wpEQV6OA8u7w299KuPM9Q19OuMgMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/StakeHolder.vue?macro=true";
import { default as PelatihanSelesaisrMUHFotsX1Wz5f2Kufpj80hP_VFnhYi2N1ChePza5kMeta } from "/app/pages/pim/[role]/Pelatihan/PelatihanSelesai.vue?macro=true";
import { default as SelfLearningpl2qkvQThSueKyVWKDVPn_eyoxPkHstpbvHraqW4mYQMeta } from "/app/pages/pim/Pembimbing/component/SelfLearning.vue?macro=true";
import { default as TotalAbsensiE86cklqlJyeS9OKPOJXSfk9XZxGsMFVuKqEZ2FVAoTIMeta } from "/app/pages/pim/Pembimbing/component/TotalAbsensi.vue?macro=true";
import { default as MaterPelatihanqwOEoHVStEroB8ReXrr23IULCqgzzbruqoyOfTvYqKkMeta } from "/app/pages/pim/Pengajar/component/MaterPelatihan.vue?macro=true";
import { default as VideoPelatihanezTMrK7e5ms9SEAx8vwfkLUhyzofiwyxsPQ_78UXmtgMeta } from "/app/pages/pim/Pengajar/component/VideoPelatihan.vue?macro=true";
import { default as DetailElearning8qCnIdi45RewqVSgJqZINUsEOr1dek7JFYig70_45daPwMeta } from "/app/pages/pim/Penguji/component/DetailElearning.vue?macro=true";
import { default as DetailElearningpzpvf0IX7nGGtdj9wR_uAwoWwJq7HV45GcunnZiuyekMeta } from "/app/pages/pim/Peserta/component/DetailElearning.vue?macro=true";
import { default as indexaDcvq1pguxCubYdX2I9vflyjRN4FfRtjTbQQW4IebH8Meta } from "/app/pages/pembelajaran-ekosistem/dashboard/index.vue?macro=true";
import { default as _91guid_93q3EQFrGJUET0elNnen9BGQkIMQWjOK4cKiVSj9CteIgMeta } from "/app/pages/pembelajaran-mandiri/enrollment/[guid].vue?macro=true";
import { default as index2VTPOa9ZCFFp9NY9NbxX4zguELFLOqWa2L0jm4kEIWIMeta } from "/app/pages/pembelajaran-wajib/swajar-[type]/index.vue?macro=true";
import { default as profilIzIaW_ftOHMr1NcBzMBGB6omv6Qcmut_45RZi0b27Pfb4Meta } from "/app/pages/pembelajaran-wajib/terintegrasi/profil.vue?macro=true";
import { default as PelatihanBerjalan_45HZZCHSKR8_JEZP42hQiBfovjqjVezRhlFxiByO92PQMeta } from "/app/pages/pim/[role]/Pelatihan/PelatihanBerjalan.vue?macro=true";
import { default as DetailElearningAyc8bgmj07vYZHrKhEzx0IdytQzMac3m4EmKQaokrK4Meta } from "/app/pages/pim/Pengajar/component/DetailElearning.vue?macro=true";
import { default as EvaluasiSubtansi9linK81_ajizKyneX2OhtjOapxgs1OPRMaMz1WoO3ggMeta } from "/app/pages/pim/Peserta/Elearning/EvaluasiSubtansi.vue?macro=true";
import { default as profilXShz_gR3EXgyn4VUmjtfI1PcvOrzDtcmmHH2wFsHkFAMeta } from "/app/pages/pembelajaran-wajib/swajar-[type]/profil.vue?macro=true";
import { default as inovasirUcPY8GpEjG_a6CzfLriWftC6Yjymqg6ig2TToEVY3kMeta } from "/app/pages/pembelajaran-wajib/terintegrasi/inovasi.vue?macro=true";
import { default as AksiPerubahanavReGM55KGbYIQgNrhRjql3sndXYHMkWpHxUa2l4rYsMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/AksiPerubahan.vue?macro=true";
import { default as JadwalPentingp4HrfPmaUoqZRYgteosPW32PMFNx22Bb4XueRueuijYMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/JadwalPenting.vue?macro=true";
import { default as SettingAgendaxFiEdFSJfzoXxtzmusP7_P_45BmhiuKoKc1HFYHQ56ZlcMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/SettingAgenda.vue?macro=true";
import { default as StudiLapangan8pGPAFBLF_iBCGPz_jeNyykVq0S8XZog95DMnu9O_45McMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/StudiLapangan.vue?macro=true";
import { default as TugasIndividuMR1llXpsPZurb3uBoWew4ZacP30FYYo6Y9cPw5gbzIYMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/TugasIndividu.vue?macro=true";
import { default as TugasKelompokwt3yelomGzqX1ME1SpUCZtDASdxooUiXOKe2oqxRtugMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/TugasKelompok.vue?macro=true";
import { default as MaterPelatihanA4UZGPRgx3hmzu7fzGQUzf8P47mxddAOrTNLqhbPgNUMeta } from "/app/pages/pim/Pembimbing/component/MaterPelatihan.vue?macro=true";
import { default as VideoPelatihantlluclZPKjKb4K2QJCuoTXukyXEAoTehgn3CymGr0KYMeta } from "/app/pages/pim/Pembimbing/component/VideoPelatihan.vue?macro=true";
import { default as index3ewzqhe3wpdQHnqf3vzPfYKS_45PX8xx3lQTr4M_45Ex21EMeta } from "/app/pages/pim/Peserta/Elearning/AgendaKelas/index.vue?macro=true";
import { default as index1OEQyBAXYU9LLOrJBcN4K_45FJ_453yMf60EcqwCAvuCBP4Meta } from "/app/pages/pembelajaran-teknis-dan-fungsional/index.vue?macro=true";
import { default as SettingShedulef067D3aw68ODN6DsbOCQ9RbPxVqdReSTiY_45SX95HnHQMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/SettingShedule.vue?macro=true";
import { default as VisitasiAgendaPcIWa7PYtcRkkQ5YgGGL_4526390ixyIOnPazZXlar_45uEMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/VisitasiAgenda.vue?macro=true";
import { default as KelompokPolicyPapers6eSkqPG8mTaixEDXgE9cfRZVUSb9dXEr0hqs3v2L2YMeta } from "/app/pages/pim/Mentor/Elearning/KelompokPolicyPaper.vue?macro=true";
import { default as DetailElearningOpdZ1gnqRBL_45iNeXogSihzHyQn96xSBtRiARiudrsW8Meta } from "/app/pages/pim/Pembimbing/component/DetailElearning.vue?macro=true";
import { default as _91slug_93mWWAW2DLJycad0OooQpchj1MRq9jF0_oJXd_452RaLqvsMeta } from "/app/pages/pembelajaran-teknis-dan-fungsional/detail/[slug].vue?macro=true";
import { default as detailuIQLkTPF2kXTRvHIb_45ITRQWVdekLxUsxBxgmAGJ6i48Meta } from "/app/pages/pembelajaran-teknis-dan-fungsional/detail.vue?macro=true";
import { default as JawabanEvaluasiuhVCU_KRg52UlKyKYhBopnYAsEKLjNi39mVZqYebBfMMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/JawabanEvaluasi.vue?macro=true";
import { default as ProyekPerubahanZRQFga4wSDhIa9j2LGPJRa9BO9w3pGUQNwSoB3kr1oIMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/ProyekPerubahan.vue?macro=true";
import { default as VisitasiKepemimpinanx4Yf_45sb7fTELd2ktgrRYMX4FhXhPAeodqED5N_456oC0EMeta } from "/app/pages/pim/[role]/Referensi/VisitasiKepemimpinan.vue?macro=true";
import { default as KelompokPolicyPaperEUCJWPGKW0d5ijKSVaOirDTmqYw4IMr5LWR6X6W9hqUMeta } from "/app/pages/pim/Penguji/Elearning/KelompokPolicyPaper.vue?macro=true";
import { default as EvaluasiSubtansi2Iw0yyJSSnn8HNSMqflj03oWF48F7_MuJD7DIWhQp5EMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/EvaluasiSubtansi.vue?macro=true";
import { default as PenilaianPesertanu5JSS_45PZO_VvTZjnOjQ0v8teqzJ9e11hkB4FBMQAAUMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/PenilaianPeserta.vue?macro=true";
import { default as ChatPesertaLRPH7oC86ij7mzqFk0ZIf2Xz27Mn_uVxyUS2UJ9iLFQMeta } from "/app/pages/pim/Mentor/Elearning/component/ChatPeserta.vue?macro=true";
import { default as KelompokAksiPerubahanSZ6qR47N7bHn3qlM8DrqWfRCaWsta9INP4FFNBTlhcAMeta } from "/app/pages/pim/Mentor/Elearning/KelompokAksiPerubahan.vue?macro=true";
import { default as KelompokStudyLapangannx_8YyM3FN9ZC8bUvI_om_45VA47wRRgasL85xjlwtkt8Meta } from "/app/pages/pim/Mentor/Elearning/KelompokStudyLapangan.vue?macro=true";
import { default as ChatMentor2Gnz4R3Ucssi_tTQJwieaCU3Zcw_VGHAN7NJEcamiDAMeta } from "/app/pages/pim/Penguji/Elearning/component/ChatMentor.vue?macro=true";
import { default as ChatMentor2bqGD2cXclpdo5ep3fVElZv3L5aROoxgnE5dE14TSoQMeta } from "/app/pages/pim/Peserta/Elearning/component/ChatMentor.vue?macro=true";
import { default as VisitasiKepemimpinanlm407yhu5lEkcbZSPoC2SaFlPnxME851zG_457Rg_45l6MUMeta } from "/app/pages/pim/Peserta/Elearning/VisitasiKepemimpinan.vue?macro=true";
import { default as indexBz4d6bWItfneORaFTjU9EUEA5inzC22rNOmrwxZ7pbIMeta } from "/app/pages/portal-pembelajaran/orientasi-[type]/index.vue?macro=true";
import { default as indexoTKwI7K4MZvlpHaajTnNw_45GZ1kjgPdDGoXi07sNz2eYMeta } from "/app/pages/revamp/portal-pembelajaran/terjadwal/index.vue?macro=true";
import { default as tugasDxx0SsdG0_FV9OXo_45eE7rsiAqm7YNtb1HjlpuqNP5VkMeta } from "/app/pages/revamp/portal-pembelajaran/terjadwal/tugas.vue?macro=true";
import { default as _91slug_93jPyev6VQXnp_455xSs_jkRean0U0Bkyc3bARtKKeOz9ZMMeta } from "/app/pages/pembelajaran-teknis-dan-fungsional/formulir/[slug].vue?macro=true";
import { default as formulir3C07NJ099SdrXfTB_45p_45IAglaLVoU1MmcJdJSPrypMZEMeta } from "/app/pages/pembelajaran-teknis-dan-fungsional/formulir.vue?macro=true";
import { default as SubPenilaian6q0gvPnUVKxwIdYG0Tb8QKr4KZyKuAWz1bLwqWHTEDgMeta } from "/app/pages/pim/[role]/Referensi/component/SubPenilaian.vue?macro=true";
import { default as DiskusiTugasyoDSkesXUOckoJI2e4IMIwINKjC8_efduLoEYxOEwPwMeta } from "/app/pages/pim/Mentor/Elearning/component/DiskusiTugas.vue?macro=true";
import { default as SubPenilaian8J7o7REn5AFtEB6ULQr3YgH_45o4HOzEnr6HO7kAe6MXEMeta } from "/app/pages/pim/Mentor/Elearning/component/SubPenilaian.vue?macro=true";
import { default as KelompokVisitasiAgendaAdVvHe1lpPGggOBLnvk_45kLfBiyIzAxYumJqgIWQrdmMMeta } from "/app/pages/pim/Mentor/Elearning/KelompokVisitasiAgenda.vue?macro=true";
import { default as KelompokAksiPerubahantD_45JpYiIJB_5yzCbliQKhwdXyQhbzyKTWHAaMgUOKpsMeta } from "/app/pages/pim/Penguji/Elearning/KelompokAksiPerubahan.vue?macro=true";
import { default as KelompokStudyLapanganL590ety_45cBmp81H3EcYKc3YhVFiW0NLiW0a83GD6QdIMeta } from "/app/pages/pim/Penguji/Elearning/KelompokStudyLapangan.vue?macro=true";
import { default as TatapMayag7EE31ndS9UWmprISOfd2HMUy35vtIahDHI5BSb5Jm8Meta } from "/app/pages/pim/Peserta/Elearning/AgendaKelas/TatapMaya.vue?macro=true";
import { default as KelompokPolicyPaperajRMPSfGqJrFE7EBn0HufN4VfsBe_45KbeYQubElG0vp0Meta } from "/app/pages/pim/Pembimbing/Elearning/KelompokPolicyPaper.vue?macro=true";
import { default as DiskusiTugasB3BEffFA6Pk3k_45B_tqDyXwnMuaBOyFJERt3i3wojkx0Meta } from "/app/pages/pim/Penguji/Elearning/component/DiskusiTugas.vue?macro=true";
import { default as SubPenilaianQqtfCQmNdxU1OH0sfkNxU2Ekd6Bfu87aYTneLfB_8TUMeta } from "/app/pages/pim/Penguji/Elearning/component/SubPenilaian.vue?macro=true";
import { default as KelompokVisitasiAgendaeUTzHNt9FrUFXOfwYy0Hox7GrOSZQrR_45p8Q2XD6PkhsMeta } from "/app/pages/pim/Penguji/Elearning/KelompokVisitasiAgenda.vue?macro=true";
import { default as DiskusiTugasoljL023GYVxjGH8Iw8kULv23wFUuwbCTbB4GaWur4CsMeta } from "/app/pages/pim/Peserta/Elearning/component/DiskusiTugas.vue?macro=true";
import { default as indexHsYqfgZyxkCg3XGGiIGmm7qpbarX5a2Dtlo6NhWEUWsMeta } from "/app/pages/pembelajaran-wajib/swajar-[type]/jurnal/index.vue?macro=true";
import { default as proyek_45perubahanrMawSrovacr9cltS04tQkLfAcOWYsJmnTkKz_JbAgfEMeta } from "/app/pages/pembelajaran-wajib/terjadwal/proyek-perubahan.vue?macro=true";
import { default as TugasMateriIndividuRicGSDqH_K8_a7JBSk9ne_NyY4xHGU9b5UU238qCxrcMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/TugasMateriIndividu.vue?macro=true";
import { default as DetailKelompokOd2GvMVAhbZSUo2Yu8hOac7Orq4n3vQnX1c6T5R1Pk4Meta } from "/app/pages/pim/Mentor/Elearning/component/DetailKelompok.vue?macro=true";
import { default as DataKelompokOA08VWJ7s1XH3X32_45lIZ0933h46XZUqzo9LALh4ZPDIMeta } from "/app/pages/pim/Pengajar/Elearning/component/DataKelompok.vue?macro=true";
import { default as AturPenilaianBnc56jSZyYRuPMTj246K_45vhUGVfoMhme_45JOVmjuazKkMeta } from "/app/pages/pim/Penguji/Elearning/component/AturPenilaian.vue?macro=true";
import { default as microlearningePeDllffmWAP99X96qQTbdCkjE4s5nZU86Baz6dkQy4Meta } from "/app/pages/pembelajaran-wajib/swajar-[type]/microlearning.vue?macro=true";
import { default as evaluasi_45akademikAjJv2qW_45jxLVOv8l2bx95Gppd9FzPNihRJT3Di1P6lsMeta } from "/app/pages/pembelajaran-wajib/terjadwal/evaluasi-akademik.vue?macro=true";
import { default as VisitasiKepemimpinan_45WuYP517X0bcu22ix5AhuxHXj97yXLGIw5Q_wkjYMJcMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/VisitasiKepemimpinan.vue?macro=true";
import { default as ChatPeserta7e5bWEYc2Gh96aNKSpR584pC82ngRaTzRzh9eNDTVlsMeta } from "/app/pages/pim/Pembimbing/Elearning/component/ChatPeserta.vue?macro=true";
import { default as KelompokAksiPerubahanRdMgi6thw6d8X53qOgabUrPBoLxd6sOmHyqZKEfRMM8Meta } from "/app/pages/pim/Pembimbing/Elearning/KelompokAksiPerubahan.vue?macro=true";
import { default as KelompokStudyLapangane2fwlJ5vyfyUo42INfgKy7J_YP3kpxfPFxQpd0_451dtEMeta } from "/app/pages/pim/Pembimbing/Elearning/KelompokStudyLapangan.vue?macro=true";
import { default as AturPenilaian4hc3uo5PHY23IVPgLnx_45g8V5ra3ptO_45NNdKN91ydS6AMeta } from "/app/pages/pim/Pengajar/Elearning/component/AturPenilaian.vue?macro=true";
import { default as ChatPembimbing4WgotbP2Xoh8BVX_rFeflzplw2mYu5pU4FQcnn77j7AMeta } from "/app/pages/pim/Penguji/Elearning/component/ChatPembimbing.vue?macro=true";
import { default as DetailKelompokrDJBMIFudEjFeqaPFrOFOuB9rIDhwSKBRF_YZCMWYVUMeta } from "/app/pages/pim/Penguji/Elearning/component/DetailKelompok.vue?macro=true";
import { default as ChatPembimbing_o5mpZ47RUie_nnjRAOVBEXRdd4eGUPMdQ1meAanYw8Meta } from "/app/pages/pim/Peserta/Elearning/component/ChatPembimbing.vue?macro=true";
import { default as DetailKelompok4fVfrfmHFmrqfdE6G8TWCKVrfoYOSN0XvdNG_ncM4_45sMeta } from "/app/pages/pim/Peserta/Elearning/component/DetailKelompok.vue?macro=true";
import { default as indexKnpMZo9cWEzrAFTh7ftTVpoWTCk3FTzCfH9IP6RUO8IMeta } from "/app/pages/revamp/portal-pembelajaran/swajar-[type]/index.vue?macro=true";
import { default as TugasPolicyPaperKG_45cwlfbYdAgFcYZPP_45PRnxjw_BsRpEnl3UL17XRz2AMeta } from "/app/pages/pim/Mentor/Elearning/component/TugasPolicyPaper.vue?macro=true";
import { default as DiskusiTugasAw_45008OVhy6OD4lj9rpb63LfGs044EseKJJANssIG9kMeta } from "/app/pages/pim/Pembimbing/Elearning/component/DiskusiTugas.vue?macro=true";
import { default as SubPenilaianf7kt5GGkC5PnA6LRXXnEaBA7chPkxtSNFGO7rNGHucgMeta } from "/app/pages/pim/Pembimbing/Elearning/component/SubPenilaian.vue?macro=true";
import { default as KelompokVisitasiAgendakAtZbEIZk56bKza_4tMxtJ5tKIavze_45idsGTIJZK9acMeta } from "/app/pages/pim/Pembimbing/Elearning/KelompokVisitasiAgenda.vue?macro=true";
import { default as TugasElearningGrkXtcoSIwd_nOdk_4589ntp0uzdBBdDhjQ8W_Ac8CD_45YMeta } from "/app/pages/pim/Pengajar/Elearning/component/TugasElearning.vue?macro=true";
import { default as TugasIndividuhd3D3PWQzh9C2h45BgnCQV8YEbMphMlrcHiF4f2_45LSkMeta } from "/app/pages/pim/Peserta/Elearning/AgendaKelas/TugasIndividu.vue?macro=true";
import { default as TugasKelompokDLrnKwpBqm9GvTioToRINf5Ay3r3stiMZ_45EEcz5z__kMeta } from "/app/pages/pim/Peserta/Elearning/AgendaKelas/TugasKelompok.vue?macro=true";
import { default as indexDPMaA56siGShSiEqtxxMJjJib2MFyAY5yPef08Nm_SkMeta } from "/app/pages/revamp/pembelajaran-teknis-dan-fungsional/index.vue?macro=true";
import { default as _91slug_93RCw5avyslNGm4vgS9co95puiHWKFDVEZPQI_fInbJx0Meta } from "/app/pages/revamp/portal-pembelajaran/swajar-[type]/[slug].vue?macro=true";
import { default as jurnaleq0TQ4rKVGyGNd8dFOZJ_454vzKNIO9u_45WwzMNWCqu2i8Meta } from "/app/pages/revamp/portal-pembelajaran/swajar-[type]/jurnal.vue?macro=true";
import { default as profilFPZV34lFo3o_45cN7eWZ7Mo9QWgtlpRBs2wbx9_45CHv3JIMeta } from "/app/pages/revamp/portal-pembelajaran/swajar-[type]/profil.vue?macro=true";
import { default as index_45HQjPTJlQVM189OtL1T3pVbK6Lb3wl_nws8g9vmlyNcMeta } from "/app/pages/revamp/portal-pembelajaran/terjadwal/kuis/index.vue?macro=true";
import { default as status_45usulanTrEPU_vNN6_vuV6NzDcQXeOOIGDYEfRCfhg2_jlTN1MMeta } from "/app/pages/pembelajaran-teknis-dan-fungsional/status-usulan.vue?macro=true";
import { default as TugasPolicyPaper_RGr8TMOZEkkQ3wFpQEVLqbt_SaaQ0qlGXP9MosTYnoMeta } from "/app/pages/pim/Penguji/Elearning/component/TugasPolicyPaper.vue?macro=true";
import { default as DataPIC6bTlymmh8Ht2MUq9tLw3CuKLzqsjrSkPDryzSsWfpOsMeta } from "/app/pages/pim/Peserta/Data/MasterDataAdministrator/DataPIC.vue?macro=true";
import { default as DetailLearningObKsenUTroVhunS5_O4sYZDZDMFj9EVfxGssKdFEo7wMeta } from "/app/pages/pim/Peserta/Elearning/AgendaKelas/DetailLearning.vue?macro=true";
import { default as detailI7DSV5NNtJi8kWudlUer0INNtwnFVLMsKMT4R6faRgQMeta } from "/app/pages/revamp/pembelajaran-teknis-dan-fungsional/detail.vue?macro=true";
import { default as _91slug_93y6bfZoggxCtE8_453InozhhqTDBARTAjj__0YkQ9SNIBEMeta } from "/app/pages/revamp/portal-pembelajaran/terjadwal/kuis/[slug].vue?macro=true";
import { default as evaluasi_45akademikNIJlsh9NG2K4Fu9khRcGzfRzHHOS0dybv7nmFo5Ksq0Meta } from "/app/pages/pembelajaran-wajib/terintegrasi/evaluasi-akademik.vue?macro=true";
import { default as TugasAksiPerubahanSOH1MgwhKrNNSXOHw5y2oUwYhdIoQMh0Gn6WFRJ_45gY0Meta } from "/app/pages/pim/Mentor/Elearning/component/TugasAksiPerubahan.vue?macro=true";
import { default as TugasStudyLapangan_0nGreldI1lKr_45x9mOQmEZ1n20AfHYAWoJDpnoTTeKUMeta } from "/app/pages/pim/Mentor/Elearning/component/TugasStudyLapangan.vue?macro=true";
import { default as KelompokVisitasiKepemimpinandjB6MMuqfeTkKy9Aea_45MUUfkGSR_C8SAWdoBg_IRC3MMeta } from "/app/pages/pim/Mentor/Elearning/KelompokVisitasiKepemimpinan.vue?macro=true";
import { default as DetailKelompoktC_GOYyrIOvwY2ZMVVWAOZk2plHHT2Fe7pZmQvkoUkUMeta } from "/app/pages/pim/Pembimbing/Elearning/component/DetailKelompok.vue?macro=true";
import { default as indexxrsmtRlDZpJMuWzVN7qSSu2oYt50mJfa7F1mpZd1xnIMeta } from "/app/pages/revamp/portal-pembelajaran/orientasi-[type]/index.vue?macro=true";
import { default as TugasVisitasiAgendacbxWPf5cpMAES00k1U73RXEH_sMZB18f6ueszaLSt_MMeta } from "/app/pages/pim/Mentor/Elearning/component/TugasVisitasiAgenda.vue?macro=true";
import { default as TugasAksiPerubahanz3hTRPYbm7G8twcFsx_45tJrAjU50ZqaA_sUw_45VSjm_45qgMeta } from "/app/pages/pim/Penguji/Elearning/component/TugasAksiPerubahan.vue?macro=true";
import { default as TugasStudyLapangan6uEANzDRXg6ViPlvURVQqpVGeV7IB4ObrHtV4Gy4cBoMeta } from "/app/pages/pim/Penguji/Elearning/component/TugasStudyLapangan.vue?macro=true";
import { default as KelompokVisitasiKepemimpinan1dkQE7xer8mv2Lqw2a9LJMTJVCiUZAQGQQ8y26wgWvQMeta } from "/app/pages/pim/Penguji/Elearning/KelompokVisitasiKepemimpinan.vue?macro=true";
import { default as formulir4KYp8k225eFhTwGdZue9lmyW3tqjO_456n3n_mQLm7spYMeta } from "/app/pages/revamp/pembelajaran-teknis-dan-fungsional/formulir.vue?macro=true";
import { default as LinkForm59bkLgXykIVorj6hw6XsQ3o40rAL5Qyn58PIXk6s9KcMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/LinkForm.vue?macro=true";
import { default as TaskFormg_45ACTnti9KbvAltC6hESMryoZTCMSJUW2QsvL7jUqTEMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/TaskForm.vue?macro=true";
import { default as TugasPolicyPaperOPcvgelpQw8UVI8cc3rmC6AdsepqzuKrc6hb9igHl70Meta } from "/app/pages/pim/Pembimbing/Elearning/component/TugasPolicyPaper.vue?macro=true";
import { default as TugasVisitasiAgendaVZxPxj9oBYCGGPKiJN9aevFCbe0ULiWuKVko7FTWv8sMeta } from "/app/pages/pim/Penguji/Elearning/component/TugasVisitasiAgenda.vue?macro=true";
import { default as evaluasi_45essayAvEfX5THrMTAeoLfQAmU5lvLva9zqLR9N2g0KcwQIC8Meta } from "/app/pages/revamp/portal-pembelajaran/terjadwal/evaluasi-essay.vue?macro=true";
import { default as FileUploadHkrVISf3l84p_j6690nIgqLN3Es6am8DmO8QQnzwKrEMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/FileUpload.vue?macro=true";
import { default as TugasAksiPerubahanAyLa8Vl8PPTNlsZohfMDp9ottBsUcX80I0Gd5IEDFcsMeta } from "/app/pages/pim/Pembimbing/Elearning/component/TugasAksiPerubahan.vue?macro=true";
import { default as TugasStudyLapanganvF7Qzq_45weEtzHlaGwl0Qhf_g0p6R_fBKxQs19t0vg9kMeta } from "/app/pages/pim/Pembimbing/Elearning/component/TugasStudyLapangan.vue?macro=true";
import { default as KelompokVisitasiKepemimpinan_H8VGETT_45k_77Lg2vNEk4vuhlFJ3mLzi8WuxWJtpoDQMeta } from "/app/pages/pim/Pembimbing/Elearning/KelompokVisitasiKepemimpinan.vue?macro=true";
import { default as TugasMateriIndividuZLh9FcyzY0r5VfwxvXyvDHkvde_XJs7u8KsBi_1GdhwMeta } from "/app/pages/pim/Peserta/Elearning/AgendaKelas/TugasMateriIndividu.vue?macro=true";
import { default as indexGVz0xzFvNhqB7OvoycSc4PVab6g4vOHT4CR1fve_45J24Meta } from "/app/pages/revamp/portal-pembelajaran/pembelajaran-mandiri/index.vue?macro=true";
import { default as proyek_45perubahancHBBMQ7118N5gDGzYFaBjhblQqiucjwrZm4FkObyGY0Meta } from "/app/pages/revamp/portal-pembelajaran/terjadwal/proyek-perubahan.vue?macro=true";
import { default as DiskusiTugasPolicyPapertJuchwW9UrfNzkm5c87VMhrnD6iX6usi8v42gXbNiQUMeta } from "/app/pages/pim/Mentor/Elearning/component/DiskusiTugasPolicyPaper.vue?macro=true";
import { default as TugasVisitasiAgendatHEqAC3zz5fr19AgbtueOUK5aSgVZPlOC0z1OQxR3_0Meta } from "/app/pages/pim/Pembimbing/Elearning/component/TugasVisitasiAgenda.vue?macro=true";
import { default as TugasEvaluasiSubtansieTJ9d4mPY4m1f5kV3MbJ0fHNUNtLUc2WlNv6qcDoq68Meta } from "/app/pages/pim/Pengajar/Elearning/component/TugasEvaluasiSubtansi.vue?macro=true";
import { default as indexENl2XCMTh_45dUaZh2_45n1izGYLij1KYIbLhvCnaWMdC5YMeta } from "/app/pages/portal-pembelajaran/orientasi-[type]/agenda-[id]/index.vue?macro=true";
import { default as evaluasi_45akademikzGg9imiXsv_LIacAex0l0_moYwH0WmNb30teK7fBy8AMeta } from "/app/pages/revamp/portal-pembelajaran/terjadwal/evaluasi-akademik.vue?macro=true";
import { default as LogPelatihanNUqD027RONC5nVBe84x_4514Yb92dohpLymR9W4zJrO3MMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/LogPelatihan.vue?macro=true";
import { default as DiskusiTugasPolicyPaperzb6on_nu4KppyNVppRkuqfQjEbuqDzCN5qlJC3j_3voMeta } from "/app/pages/pim/Penguji/Elearning/component/DiskusiTugasPolicyPaper.vue?macro=true";
import { default as DiskusiTugasPolicyPaperWmCfvaHsWfpFIBJTmJ5wHJx3leBqh154bVcxFufvlUQMeta } from "/app/pages/pim/Peserta/Elearning/component/DiskusiTugasPolicyPaper.vue?macro=true";
import { default as _91slug_93NCIPHsZn72Lj1i2u9kkg0dbQo45VLy_st3ZUQs8g9RIMeta } from "/app/pages/portal-pembelajaran/orientasi-[type]/agenda-[id]/[slug].vue?macro=true";
import { default as status_45usulandYrDcwHXTfzZJd5yA0UeLiM9BqgXhZkp3bsKbZ_45zlREMeta } from "/app/pages/revamp/pembelajaran-teknis-dan-fungsional/status-usulan.vue?macro=true";
import { default as AturPenilaianBb8wIgYbMCYLhUBtO1MlROV9lqPo1yhp4xgD_xd_vGYMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/AturPenilaian.vue?macro=true";
import { default as DetailKelompokPolicyBrief_45qioMXpyXp2g2ztXnwO7kgx4_iqCKhjn9E6F6jchmTQMeta } from "/app/pages/pim/Mentor/Elearning/component/DetailKelompokPolicyBrief.vue?macro=true";
import { default as DiskusiTugasStudyLapanganpxQfjoKU4g2REtkJWBrSY3L562CzqX6TxUdyOOSIh4kMeta } from "/app/pages/pim/Mentor/Elearning/component/DiskusiTugasStudyLapangan.vue?macro=true";
import { default as TugasVisitasiKepemimpinanhOopVcy_45Qi59u1D4hRb_r1To6NgTQ1RQtSIhAXSR4oQMeta } from "/app/pages/pim/Mentor/Elearning/component/TugasVisitasiKepemimpinan.vue?macro=true";
import { default as AturPenilaianPolicyPaperw7XFGasYyz1CGT_N7Eb6B_45lFIuyRjV_p04sVrcA3D1cMeta } from "/app/pages/pim/Penguji/Elearning/component/AturPenilaianPolicyPaper.vue?macro=true";
import { default as indexrsjmihRoymWQ0_453rsaARxf3q_45hD_45jVdwvqMoI_Wkhn4Meta } from "/app/pages/revamp/portal-pembelajaran/terjadwal/self-learning/index.vue?macro=true";
import { default as UploadTaskFileWty9Mlk6XOb97m5xzLieEtz9Orq74NGhZBq2KxcWQScMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/UploadTaskFile.vue?macro=true";
import { default as DiskusiTugasVisitasiAgenda5WbaHfbFCK_45IEA0kuV6CRi1tOqSeU_o5HoYLQ_NW_45C0Meta } from "/app/pages/pim/Mentor/Elearning/component/DiskusiTugasVisitasiAgenda.vue?macro=true";
import { default as DetailKelompokPolicyBriefu67ulfIGVv_770wlE3_45Y3NqiunIlVsOWOa4Ak4V8UrEMeta } from "/app/pages/pim/Penguji/Elearning/component/DetailKelompokPolicyBrief.vue?macro=true";
import { default as DiskusiTugasStudyLapanganHL0jxvBHANocb2lxF_45Q0_HCC0phqCpFlFUm0N5SXep8Meta } from "/app/pages/pim/Penguji/Elearning/component/DiskusiTugasStudyLapangan.vue?macro=true";
import { default as SubPenilaianAksiPerubahanW0rHsCgYC4KAaUA9yp2xarLOF16GkMEpOfHlItyvLToMeta } from "/app/pages/pim/Penguji/Elearning/component/SubPenilaianAksiPerubahan.vue?macro=true";
import { default as TugasVisitasiKepemimpinanwXeR74WXbJuSOoYQvtyXKYVizI9SEtw9asIL0ig_G6cMeta } from "/app/pages/pim/Penguji/Elearning/component/TugasVisitasiKepemimpinan.vue?macro=true";
import { default as DetailKelompokPolicyBriefUy3RSRo0d_Iby5cYCAHjPv70atWHl7Aj5GMaJqfPMQcMeta } from "/app/pages/pim/Peserta/Elearning/component/DetailKelompokPolicyBrief.vue?macro=true";
import { default as DiskusiTugasStudyLapanganZYDRqWNYN8VgP8nkFMBT5eNa5hV5GYF_45jYqXJVMMdPQMeta } from "/app/pages/pim/Peserta/Elearning/component/DiskusiTugasStudyLapangan.vue?macro=true";
import { default as _91slug_932mXZAN_CQjVZovtKZ5ut0Qt8mYl4PlB8PJwNjjZwd0YMeta } from "/app/pages/revamp/portal-pembelajaran/terjadwal/self-learning/[slug].vue?macro=true";
import { default as DetailKelompokStudyLapangan9_45WNCJig0unI1cKSW1hvWkNW4xL_451KQ_yXL4VNZSYfMMeta } from "/app/pages/pim/Mentor/Elearning/component/DetailKelompokStudyLapangan.vue?macro=true";
import { default as DiskusiTugasPolicyPapers7Di88gjc80dAJaFgc0VdltOX3lD_h8vTRhVKILhL10Meta } from "/app/pages/pim/Pembimbing/Elearning/component/DiskusiTugasPolicyPaper.vue?macro=true";
import { default as SubPenilaianAksiPerubahanqvZq1nJVxGiFHBP9Jyau79jhKzmaJjaXUc4y8GLqVQ8Meta } from "/app/pages/pim/Pengajar/Elearning/component/SubPenilaianAksiPerubahan.vue?macro=true";
import { default as AturPenilaianStudyLapanganCsJasCMgP85_teIjdPwGCTbITVjyNJf8BEZPmJidKeUMeta } from "/app/pages/pim/Penguji/Elearning/component/AturPenilaianStudyLapangan.vue?macro=true";
import { default as DiskusiTugasVisitasiAgendamZ5B5Q_45a8JZKyITnwp1PBDW84vHbqYhpR6fBLUXoe0EMeta } from "/app/pages/pim/Penguji/Elearning/component/DiskusiTugasVisitasiAgenda.vue?macro=true";
import { default as DiskusiTugasVisitasiAgendamd_HJdXUgmCRLRJgcVx8d1Did6H_45Kq6_xRH34V6mEpMMeta } from "/app/pages/pim/Peserta/Elearning/component/DiskusiTugasVisitasiAgenda.vue?macro=true";
import { default as rangkumanESETOv00wooA2_G5Lw72lMH_rZoln9Rvm_45Nk3izmHuMMeta } from "/app/pages/portal-pembelajaran/orientasi-[type]/agenda-[id]/rangkuman.vue?macro=true";
import { default as index5yke3ZelRcJJXuI603vQbO9o7GVzcDj_r_2_45PA5Hzz4Meta } from "/app/pages/revamp/portal-pembelajaran/swajar-[type]/kurikulum-2/index.vue?macro=true";
import { default as DetailKelompokVisitasiAgendaYON3gSiMW4j70uK8vyyQ6islcq4gk1rPP0nyuHR_GkgMeta } from "/app/pages/pim/Mentor/Elearning/component/DetailKelompokVisitasiAgenda.vue?macro=true";
import { default as AturPenilaianVisitasiAgendaraEDd4LeuiJgQfcEcp8brJ3Ouc9ZwO_K2MZj_13hcRsMeta } from "/app/pages/pim/Penguji/Elearning/component/AturPenilaianVisitasiAgenda.vue?macro=true";
import { default as DetailKelompokStudyLapangand6SFe69F6qJJsVVryySvhS_2Qr_450daqAh8Fj4jtNKTUMeta } from "/app/pages/pim/Penguji/Elearning/component/DetailKelompokStudyLapangan.vue?macro=true";
import { default as DetailKelompokStudyLapanganbWRhEb_45QXuylo4MZu8Syi_45u0muBtavznGgZaqE7_457QcMeta } from "/app/pages/pim/Peserta/Elearning/component/DetailKelompokStudyLapangan.vue?macro=true";
import { default as _91slug_93Lzx8CghA_45qIDzYwqlomw6b_45WjhC4OdBrQKXo1vUHwccMeta } from "/app/pages/revamp/portal-pembelajaran/swajar-[type]/kurikulum-2/[slug].vue?macro=true";
import { default as jurnalQL03UK5b1eM_45eK_45BGO9Z_45z1240T7J_InNBRevJVnIC0Meta } from "/app/pages/revamp/portal-pembelajaran/swajar-[type]/kurikulum-2/jurnal.vue?macro=true";
import { default as DetailKelompokPolicyBriefo2h_qB_45IqFU7s0xnOPxvKB3sN6MTsFj5aJ0poRCe9ccMeta } from "/app/pages/pim/Pembimbing/Elearning/component/DetailKelompokPolicyBrief.vue?macro=true";
import { default as DiskusiTugasStudyLapanganza_JZvV_3HIhNKO6sEnwSI0A1sCjL_K52WitJ3H8yC8Meta } from "/app/pages/pim/Pembimbing/Elearning/component/DiskusiTugasStudyLapangan.vue?macro=true";
import { default as TugasVisitasiKepemimpinan2vavbtw_45EQRD9vHgGq5lOabmLRyHeCjESDUwMLYpbVcMeta } from "/app/pages/pim/Pembimbing/Elearning/component/TugasVisitasiKepemimpinan.vue?macro=true";
import { default as DetailKelompokVisitasiAgendarPxCaslWJgkYK8yk_453LAg33Edh0m22NhfE8yAG1gNVYMeta } from "/app/pages/pim/Penguji/Elearning/component/DetailKelompokVisitasiAgenda.vue?macro=true";
import { default as DetailKelompokVisitasiAgenda3NQuwiGhRdw_lpNPA0QboYtbIXpGaN_iFbdtby2_lZwMeta } from "/app/pages/pim/Peserta/Elearning/component/DetailKelompokVisitasiAgenda.vue?macro=true";
import { default as indexTqNR8efAAb6E31c65rcZpfg943BsUIszMTlzHjD59FMMeta } from "/app/pages/revamp/portal-pembelajaran/pembelajaran-mandiri/[slug]/index.vue?macro=true";
import { default as indexVvCd3Tw5GzxjRLjofRgFWEHlOvzKaRbELkOLIMoaoW0Meta } from "/app/pages/revamp/portal-pembelajaran/swajar-[type]/microlearning/index.vue?macro=true";
import { default as indexTZjaicmB_yoI8e36cstlWDCnsnGXouRyc9mJaHreZggMeta } from "/app/pages/pembelajaran-wajib/swajar-[type]/evaluasi-akademik-[id]/index.vue?macro=true";
import { default as DiskusiTugasVisitasiAgendaE0J_N2xO1OiwwMXol54C0w_45aKDELU4RieIsojeq7w2cMeta } from "/app/pages/pim/Pembimbing/Elearning/component/DiskusiTugasVisitasiAgenda.vue?macro=true";
import { default as index2iZgEppbZ94nDReDkptqt5XNM8Gg49LqBxw8Mg_5VnMMeta } from "/app/pages/revamp/portal-pembelajaran/orientasi-[type]/agenda-[id]/index.vue?macro=true";
import { default as lesson_45nd0wQ8XPzFlTSSazGC_45fwn9kQeLBy5uRVCx4YBOGwgMeta } from "/app/pages/revamp/portal-pembelajaran/pembelajaran-mandiri/[slug]/lesson.vue?macro=true";
import { default as _91slug_93hEQmY3YYdXjJNOnv36_45c_Ds_45yeKzVgw7UbngJuvpIDwMeta } from "/app/pages/revamp/portal-pembelajaran/swajar-[type]/microlearning/[slug].vue?macro=true";
import { default as DetailKelompokStudyLapangano7jt3fNyUmXTyISDVA_Cxzuy3sVEoNFwwoA8a80QqIwMeta } from "/app/pages/pim/Pembimbing/Elearning/component/DetailKelompokStudyLapangan.vue?macro=true";
import { default as _91slug_93KaIiciJLl9XNgQBZiVGxZG8xqJTDZ_vfe1PlLxJ2wssMeta } from "/app/pages/revamp/portal-pembelajaran/orientasi-[type]/agenda-[id]/[slug].vue?macro=true";
import { default as AlacartekMVj364sMPHCtuE61qI1Kcc6idtLodLJDzrwEat5_458oMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/StakeHolder/Alacarte.vue?macro=true";
import { default as DiskusiTugasVisitasiKepemimpinan9EYN4L3Znoil196iz6Eh3QJqtPNrDU159XJVZvJeWDUMeta } from "/app/pages/pim/Mentor/Elearning/component/DiskusiTugasVisitasiKepemimpinan.vue?macro=true";
import { default as DetailKelompokVisitasiAgenda_U_206OMRVywZqThknlnS_45ZiP4Ekl62IG_zL63WNR98Meta } from "/app/pages/pim/Pembimbing/Elearning/component/DetailKelompokVisitasiAgenda.vue?macro=true";
import { default as indexOS_457N__SByk5A9dW2YJwULGgdCC1UXbNG0yJaJ_xIKYMeta } from "/app/pages/revamp/portal-pembelajaran/pembelajaran-mandiri/dashboard/index.vue?macro=true";
import { default as Mandatory8tL6LyuyN_45otXKKADTpKN9i1aL521AFjufwrAfIKdF8Meta } from "/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/StakeHolder/Mandatory.vue?macro=true";
import { default as DiskusiTugasVisitasiKepemimpinanLq9uVDjINI3_Xb5aqYoUOWv6G2iK09EpWceArMa0nHgMeta } from "/app/pages/pim/Penguji/Elearning/component/DiskusiTugasVisitasiKepemimpinan.vue?macro=true";
import { default as DiskusiTugasVisitasiKepemimpinanMI0WasEo7Jl4oJAv2gnk2yim0WCEiEe5UgZmepAsB9UMeta } from "/app/pages/pim/Peserta/Elearning/component/DiskusiTugasVisitasiKepemimpinan.vue?macro=true";
import { default as index84dB0OCYhje9mvHWuaZ8gR3E_4588WWkuYSaZ8yUGGJ0AMeta } from "/app/pages/revamp/portal-pembelajaran/swajar-[type]/evaluasi-akademik/index.vue?macro=true";
import { default as LogAbsensiLH4OEbwPBsqbo8_454KTmWZGAMTAKC2idJxCRQQ_45W3nEwMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/StakeHolder/LogAbsensi.vue?macro=true";
import { default as MentorFormivUjpwvtN5uHd8lISiHecKriwHJhbS1xLRkBhlD88M4Meta } from "/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/StakeHolder/MentorForm.vue?macro=true";
import { default as DetailKelompokVisitasiKepemimpinanOg5X33mlHkZfh5p31dZ_45c_rb6MwZCoNG0q6CXqOXPaYMeta } from "/app/pages/pim/Mentor/Elearning/component/DetailKelompokVisitasiKepemimpinan.vue?macro=true";
import { default as AturPenilaianVisitasiKepemimpinand7lfmlDA91sUV_4524tdm1WCJN3JajjneDKbTvPuoWVG8Meta } from "/app/pages/pim/Penguji/Elearning/component/AturPenilaianVisitasiKepemimpinan.vue?macro=true";
import { default as rangkuman6yPBGbo4yk_6X8pqWG2d4stzEAUORRNmpFN9hBFgtcwMeta } from "/app/pages/revamp/portal-pembelajaran/orientasi-[type]/agenda-[id]/rangkuman.vue?macro=true";
import { default as PengujiFormmopurnrKG2jZa3TesgPEWaOfUjQLHY1ejP_45DPdI36_wMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/StakeHolder/PengujiForm.vue?macro=true";
import { default as DetailKelompokVisitasiKepemimpinan_453PiOA2h8kRLPdYfSZiZ2TJ2n_45Ewh7p3e5_45HjtNwRUYMeta } from "/app/pages/pim/Penguji/Elearning/component/DetailKelompokVisitasiKepemimpinan.vue?macro=true";
import { default as DetailKelompokVisitasiKepemimpinandP8umxOMbbEYZ6CMj8WQqi8vra7L81_qTKwXxBwylPUMeta } from "/app/pages/pim/Peserta/Elearning/component/DetailKelompokVisitasiKepemimpinan.vue?macro=true";
import { default as LogElearningx1T2nryqA_45eXjgtMP1GKaVPlMhofzxIfny7zCkkPMLAMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/StakeHolder/LogElearning.vue?macro=true";
import { default as PengajarFormAyx8RdWuktBl1ZdKpd_45VEqak3p8BhcElU24CIRIgBT4Meta } from "/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/StakeHolder/PengajarForm.vue?macro=true";
import { default as DiskusiTugasVisitasiKepemimpinan2AE051_QIkeFvflRmBBMHW_45Tu7o2hzWDOUfrYtnSsq0Meta } from "/app/pages/pim/Pembimbing/Elearning/component/DiskusiTugasVisitasiKepemimpinan.vue?macro=true";
import { default as KurikulumIntiD3m6MRn5C0vnwU9uM7UpQf_45E3NIXOJdx4zBS_l8IrcoMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/StakeHolder/KurikulumInti.vue?macro=true";
import { default as SubPenilaianAksiPerubahanBjm7_WjFL0HFgJ6nIpA4DG_453UI2fvVw2VthNPZtJ6ZIMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/SubPenilaianAksiPerubahan.vue?macro=true";
import { default as PembimbingFormZQXvNRCdYcLLAUx2sGNFoh6Pk8MTT3CFAnbinJRaaKwMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/StakeHolder/PembimbingForm.vue?macro=true";
import { default as DetailKelompokVisitasiKepemimpinannu3YItlT8OBjWjdzyZOxnHMyleIgLzGmuUKYEEE1WPsMeta } from "/app/pages/pim/Pembimbing/Elearning/component/DetailKelompokVisitasiKepemimpinan.vue?macro=true";
import { default as indexnv1L1h_45_45XtSkER5H3IVWBjpPxB14enJe1Co7awMeO8cMeta } from "/app/pages/revamp/portal-pembelajaran/swajar-[type]/evaluasi-akademik-[id]/index.vue?macro=true";
import { default as LogSelflearningFQQWpLX_8diadefk35TGL_45a4VKhEugG4gboxrQZ8e4cMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/StakeHolder/LogSelflearning.vue?macro=true";
import { default as AturPenilaianEvaluasiSubtansiSp7vtuBezIxtD2kwS8iR8dGBYqw1S2TQOuDqTUtejXQMeta } from "/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/AturPenilaianEvaluasiSubtansi.vue?macro=true";
import { default as indexr4orPbVgszin01_BnXupMkCQGP2E_JBeAnrdcVB5PnYMeta } from "/app/pages/portal-pembelajaran/orientasi-[type]/agenda-[id]/evaluasi-akademik/index.vue?macro=true";
import { default as indexJg8dGshBnluN4EeoeSju7r_mHenObpAV8wzkt4xHI_IMeta } from "/app/pages/revamp/portal-pembelajaran/swajar-[type]/kurikulum-2/evaluasi-akademik/index.vue?macro=true";
import { default as indexiw8T2lDuG3ufRJE6gUQOMLtxt6zKLaD3NlVutLWU3UkMeta } from "/app/pages/revamp/portal-pembelajaran/orientasi-[type]/agenda-[id]/evaluasi-akademik/index.vue?macro=true";
export default [
  {
    name: "404",
    path: "/404",
    component: () => import("/app/pages/404.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "Panduan",
    path: "/Panduan",
    meta: PanduanibrljgmfuoaEYzwESlEDTGESXG4W5KNwzhCVg_45zvcGYMeta || {},
    component: () => import("/app/pages/Panduan.vue")
  },
  {
    name: "old",
    path: "/old",
    meta: indexngVHCtFeipGHfdVKkklVE8wVlAAHMrK8c3TZK_Z2H70Meta || {},
    component: () => import("/app/pages/old/index.vue")
  },
  {
    name: "pim",
    path: "/pim",
    meta: indexNaBQKILH2vMZ15A_457uJEdT0ZBnrL_45gEca5BJK8xNLhcMeta || {},
    component: () => import("/app/pages/pim/index.vue")
  },
  {
    name: "DasarHukum",
    path: "/DasarHukum",
    meta: DasarHukum5XiJvsSFbURQm3xoE3xSCwP5yUP_45tWMDQijGwtf9vw4Meta || {},
    component: () => import("/app/pages/DasarHukum.vue")
  },
  {
    name: "TanyaJawab",
    path: "/TanyaJawab",
    meta: TanyaJawab2s_teYsq4BK81SrUGbiAcnKRmlU5JmidLhxVtFkLZn0Meta || {},
    component: () => import("/app/pages/TanyaJawab.vue")
  },
  {
    name: "revamp",
    path: "/revamp",
    meta: indexb9seqUe3qTRAI7X64q30k1tfLhRw4FvFeKjYBzfUZIoMeta || {},
    component: () => import("/app/pages/revamp/index.vue")
  },
  {
    name: loginvc5VSS5bLd6731xzv8GjlrG6G9M_45cXEzLXkRBDoBz_45wMeta?.name,
    path: "/revamp/login",
    meta: loginvc5VSS5bLd6731xzv8GjlrG6G9M_45cXEzLXkRBDoBz_45wMeta || {},
    component: () => import("/app/pages/revamp/login.vue"),
    children: [
  {
    name: "revamp-login",
    path: "",
    component: () => import("/app/pages/revamp/login/index.vue")
  }
]
  },
  {
    name: "survei",
    path: "/survei",
    meta: { ...(indexXnPtrZQjeC06z7sB7oCqUQ870jdk7SHcJllUl_45NmiDwMeta || {}), ...{"middleware":["belajar-wajib","portal-pembelajaran"]} },
    component: () => import("/app/pages/survei/index.vue")
  },
  {
    name: "pusat-bantuan",
    path: "/pusat-bantuan",
    component: () => import("/app/pages/pusat-bantuan.vue")
  },
  {
    name: "resetPassword",
    path: "/resetPassword",
    meta: resetPasswordKEa0_45BGlUl46ZGppenCOrRFigbkL0R5K5qoJs7bf9xMMeta || {},
    component: () => import("/app/pages/resetPassword.vue")
  },
  {
    name: "ekosistem",
    path: "/ekosistem",
    meta: indexejFYWxyE8gEmNUI4t7m3X2fh8jmy6FKrpEepi9w4MXUMeta || {},
    component: () => import("/app/pages/ekosistem/index.vue")
  },
  {
    name: "forgot_password",
    path: "/forgot_password",
    meta: forgot_password_3VXyAHzsngPqArTw2_45YmgiEti824esiDhKAYVN5OusMeta || {},
    component: () => import("/app/pages/forgot_password.vue")
  },
  {
    name: "revamp-template",
    path: "/revamp/template",
    component: () => import("/app/pages/revamp/template.vue")
  },
  {
    name: "pim-role",
    path: "/pim/:role()",
    meta: indexxT0jzZUADHsm578rQZIcRDvLl6eGoHXFzgh3LYsBop0Meta || {},
    component: () => import("/app/pages/pim/[role]/index.vue")
  },
  {
    name: "pim-Mentor",
    path: "/pim/Mentor",
    meta: indexi_nOZdqbNlRaCVtHRmYqVcZWyks0MrP_tUUY7tEQhz8Meta || {},
    component: () => import("/app/pages/pim/Mentor/index.vue")
  },
  {
    name: "revamp-vpl",
    path: "/revamp/vpl",
    meta: { ...(indexoLLUpNvQeX9GqxwOh5TWLz0XebKOPM2v6WbB7k2_45yv4Meta || {}), ...{"middleware":["user-data"]} },
    component: () => import("/app/pages/revamp/vpl/index.vue")
  },
  {
    name: "RiwayatPelatihan",
    path: "/RiwayatPelatihan",
    meta: RiwayatPelatihanWz2LTCPF7R5vhrmB_mMWrL0hq6yWMPXPHWnwSqH7RB0Meta || {},
    component: () => import("/app/pages/RiwayatPelatihan.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/app/pages/maintenance/index.vue")
  },
  {
    name: "pim-Penguji",
    path: "/pim/Penguji",
    meta: indexITVvCZrSAy2mHLHGl03wK5VIkJG_ljeE8JJ7d39NSWUMeta || {},
    component: () => import("/app/pages/pim/Penguji/index.vue")
  },
  {
    name: "pim-Peserta",
    path: "/pim/Peserta",
    meta: indexizejv72Do1VnbAOu_Ptqsq_6mV1ap1sMjbwWjq5DuLEMeta || {},
    component: () => import("/app/pages/pim/Peserta/index.vue")
  },
  {
    name: "profil-saya",
    path: "/profil-saya",
    meta: { ...(indexwDwMwv3qrvyK9pP5bmfFNR0CJQtcdhhgfqulsRSZLxcMeta || {}), ...{"middleware":["auth","user-data"]} },
    component: () => import("/app/pages/profil-saya/index.vue")
  },
  {
    name: "revamp-vpl-slug",
    path: "/revamp/vpl/:slug()",
    meta: { ...(_91slug_9387uEdd_45u7a8wkpKWwiLtFAYxzLze4awVYaar8B7UxTQMeta || {}), ...{"middleware":["user-data"]} },
    component: () => import("/app/pages/revamp/vpl/[slug].vue")
  },
  {
    name: "app-privacy-policy",
    path: "/app/privacy-policy",
    component: () => import("/app/pages/app/privacy-policy.vue")
  },
  {
    name: "pim-Pengajar",
    path: "/pim/Pengajar",
    meta: indexOFd7rlAubZwAlMtzyq55o9uTUmdRm7dP0cnct3mKfOkMeta || {},
    component: () => import("/app/pages/pim/Pengajar/index.vue")
  },
  {
    name: "pim-Peserta-index_",
    path: "/pim/Peserta/index_",
    meta: index_YDWXjFPm2qk1K58pcU4qA8iC4K7yWFwN4iZvT6pSVwsMeta || {},
    component: () => import("/app/pages/pim/Peserta/index_.vue")
  },
  {
    name: "revamp-formbantuan",
    path: "/revamp/formbantuan",
    component: () => import("/app/pages/revamp/formbantuan.vue")
  },
  {
    name: "revamp-maintenance",
    path: "/revamp/maintenance",
    component: () => import("/app/pages/revamp/maintenance.vue")
  },
  {
    name: "pim-Peserta-Absensi",
    path: "/pim/Peserta/Absensi",
    meta: AbsensiHmKme4ammXvpDere_45Vg8_ZWqMRStRCnpxi9WZvkl0SUMeta || {},
    component: () => import("/app/pages/pim/Peserta/Absensi.vue")
  },
  {
    name: "revamp-pusatbantuan",
    path: "/revamp/pusatbantuan",
    component: () => import("/app/pages/revamp/pusatbantuan.vue")
  },
  {
    name: "revamp-survei",
    path: "/revamp/survei",
    meta: { ...(index5TsQCLch5Z0VdGidGosLy2detaE2X6qrkoMzKnWJb1oMeta || {}), ...{"middleware":["auth","user-data","portal-pembelajaran"]} },
    component: () => import("/app/pages/revamp/survei/index.vue")
  },
  {
    name: "pim-Pembimbing",
    path: "/pim/Pembimbing",
    meta: indexLz7Qr5QLUx6Klr3cftEXnpIhNrExmoODGO6XITjEEgAMeta || {},
    component: () => import("/app/pages/pim/Pembimbing/index.vue")
  },
  {
    name: "revamp-unduh-panduan",
    path: "/revamp/unduh-panduan",
    component: () => import("/app/pages/revamp/unduh-panduan.vue")
  },
  {
    name: "pim-role-DataMentor",
    path: "/pim/:role()/DataMentor",
    meta: DataMentorwwLs9vrwUtHcAWFf8U5IJUbv_12wP8KkS_k1KQcCol0Meta || {},
    component: () => import("/app/pages/pim/[role]/DataMentor.vue")
  },
  {
    name: "profil-saya-ubah-foto",
    path: "/profil-saya/ubah-foto",
    meta: { ...(ubah_45fotoKeqScyvgGLvhUE_nuzKs0c3_45i_45hY0CE4Jk7kjXMl6UYMeta || {}), ...{"middleware":["auth","user-data"]} },
    component: () => import("/app/pages/profil-saya/ubah-foto.vue")
  },
  {
    name: "pim-role-DataPenguji",
    path: "/pim/:role()/DataPenguji",
    meta: DataPenguji1YBAMYHda9anwQAQdgS52ycLtVSO4hiUFNwoBdfmC5oMeta || {},
    component: () => import("/app/pages/pim/[role]/DataPenguji.vue")
  },
  {
    name: "pim-role-DataPeserta",
    path: "/pim/:role()/DataPeserta",
    meta: DataPesertazej8UZqjXPUIcwdVBESsvR_38vGwYsYpM8Fr2EXVzvMMeta || {},
    component: () => import("/app/pages/pim/[role]/DataPeserta.vue")
  },
  {
    name: "pim-role-DataPengajar",
    path: "/pim/:role()/DataPengajar",
    meta: DataPengajar6ci26ueZMU3CUQUa7eOMkC8M3oQYhEt56euftnGv32UMeta || {},
    component: () => import("/app/pages/pim/[role]/DataPengajar.vue")
  },
  {
    name: "profil-saya-ubah-kontak",
    path: "/profil-saya/ubah-kontak",
    meta: { ...(ubah_45kontakthDAhPT9WobNTJHKoQeAhGcAq03tTS7FALZhVl1Uns8Meta || {}), ...{"middleware":["auth","user-data"]} },
    component: () => import("/app/pages/profil-saya/ubah-kontak.vue")
  },
  {
    name: "pembelajaran-wajib",
    path: "/pembelajaran-wajib",
    meta: indexW_IyyZEc4SLwe2w3FRPkhW6IeMvcNNhSsdowEtYwo6cMeta || {},
    component: () => import("/app/pages/pembelajaran-wajib/index.vue")
  },
  {
    name: "pembelajaran-wajib-login",
    path: "/pembelajaran-wajib/login",
    meta: loginHOv7xG2MoUbFBWh5aQpIxz_458qziDjyGfkKnhJnc4GVQMeta || {},
    component: () => import("/app/pages/pembelajaran-wajib/login.vue")
  },
  {
    name: "revamp-profil-saya",
    path: "/revamp/profil-saya",
    meta: { ...(indexAr6LJa8g4bCaiU4tHHFVsa3xtakJyfq14k2pzdfbJEsMeta || {}), ...{"middleware":["auth","user-data"]} },
    component: () => import("/app/pages/revamp/profil-saya/index.vue")
  },
  {
    name: "pim-role-DataPembimbing",
    path: "/pim/:role()/DataPembimbing",
    meta: DataPembimbingfLj83Fk_0Xc7q_45dyzzbyy54yU4JBDssp2BXlQVDKO_45YMeta || {},
    component: () => import("/app/pages/pim/[role]/DataPembimbing.vue")
  },
  {
    name: "portal-pembelajaran",
    path: "/portal-pembelajaran",
    meta: indexaxKDSO7EbrMosdxvHCtD__45w9OQEBA0DSVQpw0YyiGVsMeta || {},
    component: () => import("/app/pages/portal-pembelajaran/index.vue")
  },
  {
    name: "pembelajaran-mandiri",
    path: "/pembelajaran-mandiri",
    meta: { ...(indexsiwABq4QphOa_CrDatwbzZgaTyWWnPNE3cWeGWKSfhgMeta || {}), ...{"middleware":["belajar-wajib","ecosystem"]} },
    component: () => import("/app/pages/pembelajaran-mandiri/index.vue")
  },
  {
    name: "pim-role-Pelatihan",
    path: "/pim/:role()/Pelatihan",
    meta: indexvyZ_454W3kCPciYhAprW8AVCMAnozHi0reFp8cs4INj_45YMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/index.vue")
  },
  {
    name: "pim-role-Referensi",
    path: "/pim/:role()/Referensi",
    component: () => import("/app/pages/pim/[role]/Referensi/index.vue")
  },
  {
    name: "pim-Mentor-Elearning",
    path: "/pim/Mentor/Elearning",
    meta: indexgdctXckBWJ_45j6_45qE1RKwp6G7o4bYWMwA5uIvN9Kqo4YMeta || {},
    component: () => import("/app/pages/pim/Mentor/Elearning/index.vue")
  },
  {
    name: "pim-Peserta-MulaiPelatihan",
    path: "/pim/Peserta/MulaiPelatihan",
    meta: MulaiPelatihanaBz9GTUi_45co7N2dvqWfl_458Dcl_45fzKUZRxLbFnMFyIq0Meta || {},
    component: () => import("/app/pages/pim/Peserta/MulaiPelatihan.vue")
  },
  {
    name: "Pusat Bantuan",
    path: "/revamp/pusat-bantuan",
    meta: indexvM__456Sio2w9KQAQsKlusZorr6Wu8PrwWmJGar4j1SXkMeta || {},
    component: () => import("/app/pages/revamp/pusat-bantuan/index.vue")
  },
  {
    name: "pim-Penguji-Elearning",
    path: "/pim/Penguji/Elearning",
    meta: indexV8PylZ8P3TYc7nRNkpXD2_45R5LHNHM7l8FXdFG1zcll0Meta || {},
    component: () => import("/app/pages/pim/Penguji/Elearning/index.vue")
  },
  {
    name: "pim-Peserta-Elearning",
    path: "/pim/Peserta/Elearning",
    meta: indexAwNQoAn5noz7kf8kSAHGyBnGUxs4S_45I_vlcn_RnWmoIMeta || {},
    component: () => import("/app/pages/pim/Peserta/Elearning/index.vue")
  },
  {
    name: "pembelajaran-ekosistem",
    path: "/pembelajaran-ekosistem",
    meta: { ...(index36ZoqiEo4lqs_45v27J5vXaINP7JNUNYl_uz1E2GbzgbMMeta || {}), ...{"middleware":["belajar-wajib","ecosystem"]} },
    component: () => import("/app/pages/pembelajaran-ekosistem/index.vue")
  },
  {
    name: "pim-Pengajar-Elearning",
    path: "/pim/Pengajar/Elearning",
    meta: indext4TW3MydbVfhQ9D2ENhzFC2SOXgXBJmyAJmxQ0m2F7MMeta || {},
    component: () => import("/app/pages/pim/Pengajar/Elearning/index.vue")
  },
  {
    name: "revamp-profil-saya-ubah-foto",
    path: "/revamp/profil-saya/ubah-foto",
    meta: { ...(ubah_45fotoYVCstUppCfcS9omA4g03jC8pgPWY56WrT1G_RxHSrWQMeta || {}), ...{"middleware":["auth","user-data"]} },
    component: () => import("/app/pages/revamp/profil-saya/ubah-foto.vue")
  },
  {
    name: "pim-Peserta-SelfLearning-id",
    path: "/pim/Peserta/SelfLearning/:id()",
    meta: _91id_93vFqKc0s5gt2legiHoshL_45M7nMcj1MOtcvUyf_45nBcOKMMeta || {},
    component: () => import("/app/pages/pim/Peserta/SelfLearning/[id].vue")
  },
  {
    name: "pembelajaran-mandiri-dashboard",
    path: "/pembelajaran-mandiri/dashboard",
    meta: { ...(dashboardEaAQL2Ay7fT5J_GexCUv81DNLOgkZBUQo7UUERuZzMQMeta || {}), ...{"middleware":["belajar-wajib","ecosystem"]} },
    component: () => import("/app/pages/pembelajaran-mandiri/dashboard.vue")
  },
  {
    name: "pim-role-Administrator",
    path: "/pim/:role()/Administrator",
    meta: indexKef5O6xEF_mypZQpienmrTQZFRCPeNJsTkYTacb8pf4Meta || {},
    component: () => import("/app/pages/pim/[role]/Administrator/index.vue")
  },
  {
    name: "pim-Mentor-component-MulaiKuis",
    path: "/pim/Mentor/component/MulaiKuis",
    component: () => import("/app/pages/pim/Mentor/component/MulaiKuis.vue")
  },
  {
    name: "pim-Pembimbing-Elearning",
    path: "/pim/Pembimbing/Elearning",
    meta: indexXNcWat6Jx7gR195Gk68kVWE7R6dC8g_45DfLJux_450ZuhQMeta || {},
    component: () => import("/app/pages/pim/Pembimbing/Elearning/index.vue")
  },
  {
    name: "pim-Peserta-SelfLearning",
    path: "/pim/Peserta/SelfLearning",
    meta: indexP6aClL7eA_45JECxbxeFqKrFRIqK0n5iF_GaaCckAe1_45YMeta || {},
    component: () => import("/app/pages/pim/Peserta/SelfLearning/index.vue")
  },
  {
    name: "revamp-profil-saya-ubah-kontak",
    path: "/revamp/profil-saya/ubah-kontak",
    meta: { ...(ubah_45kontakZ7HK1xBjDL_iQ3SQgVNUUxR7_45uyWGkBVzILXVuqOmCgMeta || {}), ...{"middleware":["auth","user-data"]} },
    component: () => import("/app/pages/revamp/profil-saya/ubah-kontak.vue")
  },
  {
    name: "pim-role-Pelatihan-id",
    path: "/pim/:role()/Pelatihan/:id()",
    meta: indexVxxipsIAL7mRqLJR8HKtaImdmB1lLb1cRoBOM7Q_4562YMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/index.vue")
  },
  {
    name: "pim-role-Referensi-BukuManual",
    path: "/pim/:role()/Referensi/BukuManual",
    meta: BukuManualRyv8RO5S1PvTQKB_AVRimVdETOcqXqXGaSQXoALC9U8Meta || {},
    component: () => import("/app/pages/pim/[role]/Referensi/BukuManual.vue")
  },
  {
    name: "pim-Penguji-component-MulaiKuis",
    path: "/pim/Penguji/component/MulaiKuis",
    component: () => import("/app/pages/pim/Penguji/component/MulaiKuis.vue")
  },
  {
    name: "pim-Peserta-Agenda-Pembelajaran",
    path: "/pim/Peserta/Agenda-Pembelajaran",
    meta: Agenda_45PembelajaranAWkjwjc4ZiEVQoJlHvgXG0u_45BRrn6LnKsdAZuWaoZMEMeta || {},
    component: () => import("/app/pages/pim/Peserta/Agenda-Pembelajaran.vue")
  },
  {
    name: "pim-Peserta-component-MulaiKuis",
    path: "/pim/Peserta/component/MulaiKuis",
    component: () => import("/app/pages/pim/Peserta/component/MulaiKuis.vue")
  },
  {
    name: "pim-role-Administrator-DataPIC",
    path: "/pim/:role()/Administrator/DataPIC",
    meta: DataPICKKerYdaqDCCeTty_45s4yB531VpinT3gwcH4cje5f7ygQMeta || {},
    component: () => import("/app/pages/pim/[role]/Administrator/DataPIC.vue")
  },
  {
    name: "pim-role-Referensi-Materi-id",
    path: "/pim/:role()/Referensi/Materi/:id()",
    meta: _91id_93xRmqnovWGh2QmETm8MqMOPPSig6_kXdMCOI40loesQMMeta || {},
    component: () => import("/app/pages/pim/[role]/Referensi/Materi/[id].vue")
  },
  {
    name: "pim-role-Referensi-PolicyPaper",
    path: "/pim/:role()/Referensi/PolicyPaper",
    meta: PolicyPaper1Iq7TBSsWbxKfuaBVYu5CwnBK3Z_45ubdtjRvJNg9cGuEMeta || {},
    component: () => import("/app/pages/pim/[role]/Referensi/PolicyPaper.vue")
  },
  {
    name: "pim-Pengajar-component-MulaiKuis",
    path: "/pim/Pengajar/component/MulaiKuis",
    component: () => import("/app/pages/pim/Pengajar/component/MulaiKuis.vue")
  },
  {
    name: "revamp-portal-pembelajaran",
    path: "/revamp/portal-pembelajaran",
    meta: indexTbzIuiIvJ8t4uPtI2_sETp7KwYIAD8rC8W_459xhIAzrcMeta || {},
    component: () => import("/app/pages/revamp/portal-pembelajaran/index.vue")
  },
  {
    name: "revamp-pusat-bantuan-formbantuan",
    path: "/revamp/pusat-bantuan/formbantuan",
    meta: formbantuandhOV_45npVO5KWXWGGwovK7kvCXXnLU_45A4tUUhABq3sBoMeta || {},
    component: () => import("/app/pages/revamp/pusat-bantuan/formbantuan.vue")
  },
  {
    name: "pembelajaran-mandiri-slug",
    path: "/pembelajaran-mandiri/:slug()",
    meta: { ...(indexoEcVeUrUFhD4AyzAmXYmuGf_R8qjs5tFOS98f_45TCKewMeta || {}), ...{"middleware":["belajar-wajib","ecosystem"]} },
    component: () => import("/app/pages/pembelajaran-mandiri/[slug]/index.vue")
  },
  {
    name: "pembelajaran-wajib-terjadwal-quiz",
    path: "/pembelajaran-wajib/terjadwal/quiz",
    meta: quizvGX18oARwER76PR8LEUyPdETb4G4QgE5zxEyd8qLF08Meta || {},
    component: () => import("/app/pages/pembelajaran-wajib/terjadwal/quiz.vue")
  },
  {
    name: "pim-role-Referensi-Materi",
    path: "/pim/:role()/Referensi/Materi",
    meta: index7ScPF8qbu6SHtSiQdVObihvelVBsxxUeV8eH6BiDUsoMeta || {},
    component: () => import("/app/pages/pim/[role]/Referensi/Materi/index.vue")
  },
  {
    name: "pim-Mentor-component-SelfLearning",
    path: "/pim/Mentor/component/SelfLearning",
    component: () => import("/app/pages/pim/Mentor/component/SelfLearning.vue")
  },
  {
    name: "pim-Mentor-component-TotalAbsensi",
    path: "/pim/Mentor/component/TotalAbsensi",
    component: () => import("/app/pages/pim/Mentor/component/TotalAbsensi.vue")
  },
  {
    name: "pim-Peserta-Elearning-PolicyBrief",
    path: "/pim/Peserta/Elearning/PolicyBrief",
    meta: PolicyBriefM5FYao6fTM3_45GiUkXbN9KE9J6IoaQfQ_q7_45NTbkWA9cMeta || {},
    component: () => import("/app/pages/pim/Peserta/Elearning/PolicyBrief.vue")
  },
  {
    name: "pembelajaran-mandiri-slug-lesson",
    path: "/pembelajaran-mandiri/:slug()/lesson",
    meta: { ...(lessonncPnve3P0Litw0GFVW6lgA1eZB_45pxfiv4m22Mcb6sYwMeta || {}), ...{"middleware":["belajar-wajib","ecosystem"]} },
    component: () => import("/app/pages/pembelajaran-mandiri/[slug]/lesson.vue")
  },
  {
    name: "pembelajaran-wajib-terjadwal",
    path: "/pembelajaran-wajib/terjadwal",
    meta: { ...(index_2ciT6PO9SH4azQq94NquOeoiwxha3mACYUUMEhapgUMeta || {}), ...{"middleware":["belajar-wajib"]} },
    component: () => import("/app/pages/pembelajaran-wajib/terjadwal/index.vue")
  },
  {
    name: "pim-role-Referensi-JadwalPenting",
    path: "/pim/:role()/Referensi/JadwalPenting",
    meta: JadwalPenting8n3T_45mk4_TbjcbcP8_45xHD5dftCDS2y7EZKY1HxXV648Meta || {},
    component: () => import("/app/pages/pim/[role]/Referensi/JadwalPenting.vue")
  },
  {
    name: "pim-role-Referensi-StudiLapangan",
    path: "/pim/:role()/Referensi/StudiLapangan",
    meta: StudiLapangan6ej_45OQOsk3L7G4b6rdSPfKvfsy07Nx9hTGK_45SW0ZX_EMeta || {},
    component: () => import("/app/pages/pim/[role]/Referensi/StudiLapangan.vue")
  },
  {
    name: "pim-Pembimbing-component-MulaiKuis",
    path: "/pim/Pembimbing/component/MulaiKuis",
    component: () => import("/app/pages/pim/Pembimbing/component/MulaiKuis.vue")
  },
  {
    name: "pim-Penguji-component-SelfLearning",
    path: "/pim/Penguji/component/SelfLearning",
    component: () => import("/app/pages/pim/Penguji/component/SelfLearning.vue")
  },
  {
    name: "pim-Penguji-component-TotalAbsensi",
    path: "/pim/Penguji/component/TotalAbsensi",
    component: () => import("/app/pages/pim/Penguji/component/TotalAbsensi.vue")
  },
  {
    name: "pim-Peserta-component-SelfLearning",
    path: "/pim/Peserta/component/SelfLearning",
    component: () => import("/app/pages/pim/Peserta/component/SelfLearning.vue")
  },
  {
    name: "pim-Peserta-component-TotalAbsensi",
    path: "/pim/Peserta/component/TotalAbsensi",
    component: () => import("/app/pages/pim/Peserta/component/TotalAbsensi.vue")
  },
  {
    name: "pembelajaran-ekosistem-slug",
    path: "/pembelajaran-ekosistem/:slug()",
    meta: { ...(indexUSGsQT8LU0xxnOvEaNObm_taWL_BryJAM063y_45UVYoUMeta || {}), ...{"middleware":["belajar-wajib","ecosystem"]} },
    component: () => import("/app/pages/pembelajaran-ekosistem/[slug]/index.vue")
  },
  {
    name: "pembelajaran-wajib-terjadwal-agenda",
    path: "/pembelajaran-wajib/terjadwal/agenda",
    meta: { ...(agendaSpiw9VotTKzb2pIlzSqR5OWBdkSE854l_UinrdI7OgsMeta || {}), ...{"middleware":["belajar-wajib"]} },
    component: () => import("/app/pages/pembelajaran-wajib/terjadwal/agenda.vue")
  },
  {
    name: "pembelajaran-wajib-terjadwal-profil",
    path: "/pembelajaran-wajib/terjadwal/profil",
    meta: { ...(profil7YkVYOy87hXT5wG7TQgxeKENTursiInNDF9M8NsIW_45QMeta || {}), ...{"middleware":["belajar-wajib"]} },
    component: () => import("/app/pages/pembelajaran-wajib/terjadwal/profil.vue")
  },
  {
    name: "pim-role-Pelatihan-id-Pelatihan",
    path: "/pim/:role()/Pelatihan/:id()/Pelatihan",
    meta: PelatihanrVkyG_fqfd_a0qH6q3W_73R0NcSLy9_L6hhHyCITvMsMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/Pelatihan.vue")
  },
  {
    name: "pim-role-Pelatihan-id-TatapMaya",
    path: "/pim/:role()/Pelatihan/:id()/TatapMaya",
    meta: TatapMaya4_m7f_mAkr6HoiVoA_45vUGItf3cLI_45cEkjUfnxVWUtKEMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/TatapMaya.vue")
  },
  {
    name: "pim-role-Referensi-BobotPenilaian",
    path: "/pim/:role()/Referensi/BobotPenilaian",
    meta: BobotPenilaian_45BThKlXvhTe1G1FbjNtwqdb_45Te0q6z_45eaLA3eZDwNMwMeta || {},
    component: () => import("/app/pages/pim/[role]/Referensi/BobotPenilaian.vue")
  },
  {
    name: "pim-role-Referensi-VisitasiAgenda",
    path: "/pim/:role()/Referensi/VisitasiAgenda",
    meta: VisitasiAgendaRigu2aDpclOscPC1LFLcZLoSxHebHCCflp6NHx6iEMwMeta || {},
    component: () => import("/app/pages/pim/[role]/Referensi/VisitasiAgenda.vue")
  },
  {
    name: "pim-Mentor-component-MaterPelatihan",
    path: "/pim/Mentor/component/MaterPelatihan",
    component: () => import("/app/pages/pim/Mentor/component/MaterPelatihan.vue")
  },
  {
    name: "pim-Mentor-component-VideoPelatihan",
    path: "/pim/Mentor/component/VideoPelatihan",
    component: () => import("/app/pages/pim/Mentor/component/VideoPelatihan.vue")
  },
  {
    name: "pim-Pengajar-component-SelfLearning",
    path: "/pim/Pengajar/component/SelfLearning",
    component: () => import("/app/pages/pim/Pengajar/component/SelfLearning.vue")
  },
  {
    name: "pim-Pengajar-component-TotalAbsensi",
    path: "/pim/Pengajar/component/TotalAbsensi",
    component: () => import("/app/pages/pim/Pengajar/component/TotalAbsensi.vue")
  },
  {
    name: "pim-Peserta-Elearning-AksiPerubahan",
    path: "/pim/Peserta/Elearning/AksiPerubahan",
    meta: AksiPerubahanAHS6F_45RNJ_FpBBbHY33AF1XNcgCKsE907KAVP4CqQPUMeta || {},
    component: () => import("/app/pages/pim/Peserta/Elearning/AksiPerubahan.vue")
  },
  {
    name: "pim-Peserta-Elearning-StudyLapangan",
    path: "/pim/Peserta/Elearning/StudyLapangan",
    meta: StudyLapanganyv3TqPH_45lQu6srcubjcJlmK_45Yt0xs3a5sHd3OhI8L58Meta || {},
    component: () => import("/app/pages/pim/Peserta/Elearning/StudyLapangan.vue")
  },
  {
    name: "pim-Peserta-Pelatihan-DataPelatihan",
    path: "/pim/Peserta/Pelatihan/DataPelatihan",
    meta: DataPelatihanr23NuhZujyDsfVIQuwDSXEXDheVnSOdNQj6twto3iuYMeta || {},
    component: () => import("/app/pages/pim/Peserta/Pelatihan/DataPelatihan.vue")
  },
  {
    name: "revamp-pusat-bantuan-helpdesk",
    path: "/revamp/pusat-bantuan/helpdesk",
    meta: index9S7kYMVISnUR2TCCTXoEgI2DhCl42CjKl_45qdo0oRCxAMeta || {},
    component: () => import("/app/pages/revamp/pusat-bantuan/helpdesk/index.vue")
  },
  {
    name: "pim-role-Referensi-PertanyaanUjian",
    path: "/pim/:role()/Referensi/PertanyaanUjian",
    meta: PertanyaanUjian93QSomSH9tWpPJxOifYs9m49vPf6rmKjQTrKgruf1KgMeta || {},
    component: () => import("/app/pages/pim/[role]/Referensi/PertanyaanUjian.vue")
  },
  {
    name: "pim-role-Referensi-ProyekPerubahan",
    path: "/pim/:role()/Referensi/ProyekPerubahan",
    meta: ProyekPerubahan6dgEpC0FOy_Kt_hrxtLI3HQP3uA3pHbE_UPVEgH3iOIMeta || {},
    component: () => import("/app/pages/pim/[role]/Referensi/ProyekPerubahan.vue")
  },
  {
    name: "pim-Mentor-component-DetailElearning",
    path: "/pim/Mentor/component/DetailElearning",
    component: () => import("/app/pages/pim/Mentor/component/DetailElearning.vue")
  },
  {
    name: "pim-Penguji-component-MaterPelatihan",
    path: "/pim/Penguji/component/MaterPelatihan",
    component: () => import("/app/pages/pim/Penguji/component/MaterPelatihan.vue")
  },
  {
    name: "pim-Penguji-component-VideoPelatihan",
    path: "/pim/Penguji/component/VideoPelatihan",
    component: () => import("/app/pages/pim/Penguji/component/VideoPelatihan.vue")
  },
  {
    name: "pim-Peserta-component-MaterPelatihan",
    path: "/pim/Peserta/component/MaterPelatihan",
    component: () => import("/app/pages/pim/Peserta/component/MaterPelatihan.vue")
  },
  {
    name: "pim-Peserta-component-VideoPelatihan",
    path: "/pim/Peserta/component/VideoPelatihan",
    component: () => import("/app/pages/pim/Peserta/component/VideoPelatihan.vue")
  },
  {
    name: "pim-Peserta-Elearning-VisitasiAgenda",
    path: "/pim/Peserta/Elearning/VisitasiAgenda",
    meta: VisitasiAgendaDkb_45ZQcB_45Bj4iUxI4gwOBe9JFWR3oT5zo7Tu2NF90G8Meta || {},
    component: () => import("/app/pages/pim/Peserta/Elearning/VisitasiAgenda.vue")
  },
  {
    name: "pembelajaran-wajib-terintegrasi",
    path: "/pembelajaran-wajib/terintegrasi",
    meta: { ...(indexjgox8p_45sCRdFHXYs14ZEPf_7sh0KZmdtIwkFy3w591sMeta || {}), ...{"middleware":["belajar-wajib"]} },
    component: () => import("/app/pages/pembelajaran-wajib/terintegrasi/index.vue")
  },
  {
    name: "pim-role-Pelatihan-id-PolicyBrief",
    path: "/pim/:role()/Pelatihan/:id()/PolicyBrief",
    meta: PolicyBriefMtFkrF9JK3VE_45P1_2a4BleF654No9qRuu0taLelwSSQMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/PolicyBrief.vue")
  },
  {
    name: "pim-role-Pelatihan-id-StakeHolder",
    path: "/pim/:role()/Pelatihan/:id()/StakeHolder",
    meta: StakeHoldercbzFEnP_45RR_45sn8B0wpEQV6OA8u7w299KuPM9Q19OuMgMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/StakeHolder.vue")
  },
  {
    name: "pim-role-Pelatihan-PelatihanSelesai",
    path: "/pim/:role()/Pelatihan/PelatihanSelesai",
    meta: PelatihanSelesaisrMUHFotsX1Wz5f2Kufpj80hP_VFnhYi2N1ChePza5kMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/PelatihanSelesai.vue")
  },
  {
    name: "pim-Pembimbing-component-SelfLearning",
    path: "/pim/Pembimbing/component/SelfLearning",
    component: () => import("/app/pages/pim/Pembimbing/component/SelfLearning.vue")
  },
  {
    name: "pim-Pembimbing-component-TotalAbsensi",
    path: "/pim/Pembimbing/component/TotalAbsensi",
    component: () => import("/app/pages/pim/Pembimbing/component/TotalAbsensi.vue")
  },
  {
    name: "pim-Pengajar-component-MaterPelatihan",
    path: "/pim/Pengajar/component/MaterPelatihan",
    component: () => import("/app/pages/pim/Pengajar/component/MaterPelatihan.vue")
  },
  {
    name: "pim-Pengajar-component-VideoPelatihan",
    path: "/pim/Pengajar/component/VideoPelatihan",
    component: () => import("/app/pages/pim/Pengajar/component/VideoPelatihan.vue")
  },
  {
    name: "pim-Penguji-component-DetailElearning",
    path: "/pim/Penguji/component/DetailElearning",
    component: () => import("/app/pages/pim/Penguji/component/DetailElearning.vue")
  },
  {
    name: "pim-Peserta-component-DetailElearning",
    path: "/pim/Peserta/component/DetailElearning",
    component: () => import("/app/pages/pim/Peserta/component/DetailElearning.vue")
  },
  {
    name: "pembelajaran-ekosistem-dashboard",
    path: "/pembelajaran-ekosistem/dashboard",
    meta: { ...(indexaDcvq1pguxCubYdX2I9vflyjRN4FfRtjTbQQW4IebH8Meta || {}), ...{"middleware":["belajar-wajib","ecosystem"]} },
    component: () => import("/app/pages/pembelajaran-ekosistem/dashboard/index.vue")
  },
  {
    name: "pembelajaran-mandiri-enrollment-guid",
    path: "/pembelajaran-mandiri/enrollment/:guid()",
    meta: { ...(_91guid_93q3EQFrGJUET0elNnen9BGQkIMQWjOK4cKiVSj9CteIgMeta || {}), ...{"middleware":["belajar-wajib"]} },
    component: () => import("/app/pages/pembelajaran-mandiri/enrollment/[guid].vue")
  },
  {
    name: "pembelajaran-wajib-swajar-type",
    path: "/pembelajaran-wajib/swajar-:type()",
    meta: { ...(index2VTPOa9ZCFFp9NY9NbxX4zguELFLOqWa2L0jm4kEIWIMeta || {}), ...{"middleware":["belajar-wajib","swajar"]} },
    component: () => import("/app/pages/pembelajaran-wajib/swajar-[type]/index.vue")
  },
  {
    name: "pembelajaran-wajib-terintegrasi-profil",
    path: "/pembelajaran-wajib/terintegrasi/profil",
    meta: { ...(profilIzIaW_ftOHMr1NcBzMBGB6omv6Qcmut_45RZi0b27Pfb4Meta || {}), ...{"middleware":["belajar-wajib"]} },
    component: () => import("/app/pages/pembelajaran-wajib/terintegrasi/profil.vue")
  },
  {
    name: "pim-role-Pelatihan-PelatihanBerjalan",
    path: "/pim/:role()/Pelatihan/PelatihanBerjalan",
    meta: PelatihanBerjalan_45HZZCHSKR8_JEZP42hQiBfovjqjVezRhlFxiByO92PQMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/PelatihanBerjalan.vue")
  },
  {
    name: "pim-Pengajar-component-DetailElearning",
    path: "/pim/Pengajar/component/DetailElearning",
    component: () => import("/app/pages/pim/Pengajar/component/DetailElearning.vue")
  },
  {
    name: "pim-Peserta-Elearning-EvaluasiSubtansi",
    path: "/pim/Peserta/Elearning/EvaluasiSubtansi",
    meta: EvaluasiSubtansi9linK81_ajizKyneX2OhtjOapxgs1OPRMaMz1WoO3ggMeta || {},
    component: () => import("/app/pages/pim/Peserta/Elearning/EvaluasiSubtansi.vue")
  },
  {
    name: "pembelajaran-wajib-swajar-type-profil",
    path: "/pembelajaran-wajib/swajar-:type()/profil",
    meta: { ...(profilXShz_gR3EXgyn4VUmjtfI1PcvOrzDtcmmHH2wFsHkFAMeta || {}), ...{"middleware":["belajar-wajib","swajar"]} },
    component: () => import("/app/pages/pembelajaran-wajib/swajar-[type]/profil.vue")
  },
  {
    name: "pembelajaran-wajib-terintegrasi-inovasi",
    path: "/pembelajaran-wajib/terintegrasi/inovasi",
    meta: { ...(inovasirUcPY8GpEjG_a6CzfLriWftC6Yjymqg6ig2TToEVY3kMeta || {}), ...{"middleware":["belajar-wajib"]} },
    component: () => import("/app/pages/pembelajaran-wajib/terintegrasi/inovasi.vue")
  },
  {
    name: "pim-role-Pelatihan-id-AksiPerubahan",
    path: "/pim/:role()/Pelatihan/:id()/AksiPerubahan",
    meta: AksiPerubahanavReGM55KGbYIQgNrhRjql3sndXYHMkWpHxUa2l4rYsMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/AksiPerubahan.vue")
  },
  {
    name: "pim-role-Pelatihan-id-JadwalPenting",
    path: "/pim/:role()/Pelatihan/:id()/JadwalPenting",
    meta: JadwalPentingp4HrfPmaUoqZRYgteosPW32PMFNx22Bb4XueRueuijYMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/JadwalPenting.vue")
  },
  {
    name: "pim-role-Pelatihan-id-SettingAgenda",
    path: "/pim/:role()/Pelatihan/:id()/SettingAgenda",
    meta: SettingAgendaxFiEdFSJfzoXxtzmusP7_P_45BmhiuKoKc1HFYHQ56ZlcMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/SettingAgenda.vue")
  },
  {
    name: "pim-role-Pelatihan-id-StudiLapangan",
    path: "/pim/:role()/Pelatihan/:id()/StudiLapangan",
    meta: StudiLapangan8pGPAFBLF_iBCGPz_jeNyykVq0S8XZog95DMnu9O_45McMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/StudiLapangan.vue")
  },
  {
    name: "pim-role-Pelatihan-id-TugasIndividu",
    path: "/pim/:role()/Pelatihan/:id()/TugasIndividu",
    meta: TugasIndividuMR1llXpsPZurb3uBoWew4ZacP30FYYo6Y9cPw5gbzIYMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/TugasIndividu.vue")
  },
  {
    name: "pim-role-Pelatihan-id-TugasKelompok",
    path: "/pim/:role()/Pelatihan/:id()/TugasKelompok",
    meta: TugasKelompokwt3yelomGzqX1ME1SpUCZtDASdxooUiXOKe2oqxRtugMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/TugasKelompok.vue")
  },
  {
    name: "pim-Pembimbing-component-MaterPelatihan",
    path: "/pim/Pembimbing/component/MaterPelatihan",
    component: () => import("/app/pages/pim/Pembimbing/component/MaterPelatihan.vue")
  },
  {
    name: "pim-Pembimbing-component-VideoPelatihan",
    path: "/pim/Pembimbing/component/VideoPelatihan",
    component: () => import("/app/pages/pim/Pembimbing/component/VideoPelatihan.vue")
  },
  {
    name: "pim-Peserta-Elearning-AgendaKelas",
    path: "/pim/Peserta/Elearning/AgendaKelas",
    meta: index3ewzqhe3wpdQHnqf3vzPfYKS_45PX8xx3lQTr4M_45Ex21EMeta || {},
    component: () => import("/app/pages/pim/Peserta/Elearning/AgendaKelas/index.vue")
  },
  {
    name: "pembelajaran-teknis-dan-fungsional",
    path: "/pembelajaran-teknis-dan-fungsional",
    meta: index1OEQyBAXYU9LLOrJBcN4K_45FJ_453yMf60EcqwCAvuCBP4Meta || {},
    component: () => import("/app/pages/pembelajaran-teknis-dan-fungsional/index.vue")
  },
  {
    name: "pim-role-Pelatihan-id-SettingShedule",
    path: "/pim/:role()/Pelatihan/:id()/SettingShedule",
    meta: SettingShedulef067D3aw68ODN6DsbOCQ9RbPxVqdReSTiY_45SX95HnHQMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/SettingShedule.vue")
  },
  {
    name: "pim-role-Pelatihan-id-VisitasiAgenda",
    path: "/pim/:role()/Pelatihan/:id()/VisitasiAgenda",
    meta: VisitasiAgendaPcIWa7PYtcRkkQ5YgGGL_4526390ixyIOnPazZXlar_45uEMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/VisitasiAgenda.vue")
  },
  {
    name: "pim-Mentor-Elearning-KelompokPolicyPaper",
    path: "/pim/Mentor/Elearning/KelompokPolicyPaper",
    meta: KelompokPolicyPapers6eSkqPG8mTaixEDXgE9cfRZVUSb9dXEr0hqs3v2L2YMeta || {},
    component: () => import("/app/pages/pim/Mentor/Elearning/KelompokPolicyPaper.vue")
  },
  {
    name: "pim-Pembimbing-component-DetailElearning",
    path: "/pim/Pembimbing/component/DetailElearning",
    component: () => import("/app/pages/pim/Pembimbing/component/DetailElearning.vue")
  },
  {
    name: "pembelajaran-teknis-dan-fungsional-detail",
    path: "/pembelajaran-teknis-dan-fungsional/detail",
    meta: detailuIQLkTPF2kXTRvHIb_45ITRQWVdekLxUsxBxgmAGJ6i48Meta || {},
    component: () => import("/app/pages/pembelajaran-teknis-dan-fungsional/detail.vue"),
    children: [
  {
    name: "pembelajaran-teknis-dan-fungsional-detail-slug",
    path: ":slug()",
    meta: _91slug_93mWWAW2DLJycad0OooQpchj1MRq9jF0_oJXd_452RaLqvsMeta || {},
    component: () => import("/app/pages/pembelajaran-teknis-dan-fungsional/detail/[slug].vue")
  }
]
  },
  {
    name: "pim-role-Pelatihan-id-JawabanEvaluasi",
    path: "/pim/:role()/Pelatihan/:id()/JawabanEvaluasi",
    meta: JawabanEvaluasiuhVCU_KRg52UlKyKYhBopnYAsEKLjNi39mVZqYebBfMMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/JawabanEvaluasi.vue")
  },
  {
    name: "pim-role-Pelatihan-id-ProyekPerubahan",
    path: "/pim/:role()/Pelatihan/:id()/ProyekPerubahan",
    meta: ProyekPerubahanZRQFga4wSDhIa9j2LGPJRa9BO9w3pGUQNwSoB3kr1oIMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/ProyekPerubahan.vue")
  },
  {
    name: "pim-role-Referensi-VisitasiKepemimpinan",
    path: "/pim/:role()/Referensi/VisitasiKepemimpinan",
    meta: VisitasiKepemimpinanx4Yf_45sb7fTELd2ktgrRYMX4FhXhPAeodqED5N_456oC0EMeta || {},
    component: () => import("/app/pages/pim/[role]/Referensi/VisitasiKepemimpinan.vue")
  },
  {
    name: "pim-Penguji-Elearning-KelompokPolicyPaper",
    path: "/pim/Penguji/Elearning/KelompokPolicyPaper",
    meta: KelompokPolicyPaperEUCJWPGKW0d5ijKSVaOirDTmqYw4IMr5LWR6X6W9hqUMeta || {},
    component: () => import("/app/pages/pim/Penguji/Elearning/KelompokPolicyPaper.vue")
  },
  {
    name: "pim-role-Pelatihan-id-EvaluasiSubtansi",
    path: "/pim/:role()/Pelatihan/:id()/EvaluasiSubtansi",
    meta: EvaluasiSubtansi2Iw0yyJSSnn8HNSMqflj03oWF48F7_MuJD7DIWhQp5EMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/EvaluasiSubtansi.vue")
  },
  {
    name: "pim-role-Pelatihan-id-PenilaianPeserta",
    path: "/pim/:role()/Pelatihan/:id()/PenilaianPeserta",
    meta: PenilaianPesertanu5JSS_45PZO_VvTZjnOjQ0v8teqzJ9e11hkB4FBMQAAUMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/PenilaianPeserta.vue")
  },
  {
    name: "pim-Mentor-Elearning-component-ChatPeserta",
    path: "/pim/Mentor/Elearning/component/ChatPeserta",
    component: () => import("/app/pages/pim/Mentor/Elearning/component/ChatPeserta.vue")
  },
  {
    name: "pim-Mentor-Elearning-KelompokAksiPerubahan",
    path: "/pim/Mentor/Elearning/KelompokAksiPerubahan",
    meta: KelompokAksiPerubahanSZ6qR47N7bHn3qlM8DrqWfRCaWsta9INP4FFNBTlhcAMeta || {},
    component: () => import("/app/pages/pim/Mentor/Elearning/KelompokAksiPerubahan.vue")
  },
  {
    name: "pim-Mentor-Elearning-KelompokStudyLapangan",
    path: "/pim/Mentor/Elearning/KelompokStudyLapangan",
    meta: KelompokStudyLapangannx_8YyM3FN9ZC8bUvI_om_45VA47wRRgasL85xjlwtkt8Meta || {},
    component: () => import("/app/pages/pim/Mentor/Elearning/KelompokStudyLapangan.vue")
  },
  {
    name: "pim-Penguji-Elearning-component-ChatMentor",
    path: "/pim/Penguji/Elearning/component/ChatMentor",
    component: () => import("/app/pages/pim/Penguji/Elearning/component/ChatMentor.vue")
  },
  {
    name: "pim-Peserta-Elearning-component-ChatMentor",
    path: "/pim/Peserta/Elearning/component/ChatMentor",
    component: () => import("/app/pages/pim/Peserta/Elearning/component/ChatMentor.vue")
  },
  {
    name: "pim-Peserta-Elearning-VisitasiKepemimpinan",
    path: "/pim/Peserta/Elearning/VisitasiKepemimpinan",
    meta: VisitasiKepemimpinanlm407yhu5lEkcbZSPoC2SaFlPnxME851zG_457Rg_45l6MUMeta || {},
    component: () => import("/app/pages/pim/Peserta/Elearning/VisitasiKepemimpinan.vue")
  },
  {
    name: "portal-pembelajaran-orientasi-type",
    path: "/portal-pembelajaran/orientasi-:type()",
    meta: { ...(indexBz4d6bWItfneORaFTjU9EUEA5inzC22rNOmrwxZ7pbIMeta || {}), ...{"middleware":["auth","user-data","portal-pembelajaran","orientasi-pppk"]} },
    component: () => import("/app/pages/portal-pembelajaran/orientasi-[type]/index.vue")
  },
  {
    name: "revamp-portal-pembelajaran-terjadwal",
    path: "/revamp/portal-pembelajaran/terjadwal",
    meta: { ...(indexoTKwI7K4MZvlpHaajTnNw_45GZ1kjgPdDGoXi07sNz2eYMeta || {}), ...{"middleware":["auth","user-data","portal-pembelajaran"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/terjadwal/index.vue")
  },
  {
    name: "revamp-portal-pembelajaran-terjadwal-tugas",
    path: "/revamp/portal-pembelajaran/terjadwal/tugas",
    meta: { ...(tugasDxx0SsdG0_FV9OXo_45eE7rsiAqm7YNtb1HjlpuqNP5VkMeta || {}), ...{"middleware":["auth","user-data","portal-pembelajaran"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/terjadwal/tugas.vue")
  },
  {
    name: "pembelajaran-teknis-dan-fungsional-formulir",
    path: "/pembelajaran-teknis-dan-fungsional/formulir",
    meta: formulir3C07NJ099SdrXfTB_45p_45IAglaLVoU1MmcJdJSPrypMZEMeta || {},
    component: () => import("/app/pages/pembelajaran-teknis-dan-fungsional/formulir.vue"),
    children: [
  {
    name: "pembelajaran-teknis-dan-fungsional-formulir-slug",
    path: ":slug()",
    meta: _91slug_93jPyev6VQXnp_455xSs_jkRean0U0Bkyc3bARtKKeOz9ZMMeta || {},
    component: () => import("/app/pages/pembelajaran-teknis-dan-fungsional/formulir/[slug].vue")
  }
]
  },
  {
    name: "pim-role-Referensi-component-SubPenilaian",
    path: "/pim/:role()/Referensi/component/SubPenilaian",
    meta: SubPenilaian6q0gvPnUVKxwIdYG0Tb8QKr4KZyKuAWz1bLwqWHTEDgMeta || {},
    component: () => import("/app/pages/pim/[role]/Referensi/component/SubPenilaian.vue")
  },
  {
    name: "pim-Mentor-Elearning-component-DiskusiTugas",
    path: "/pim/Mentor/Elearning/component/DiskusiTugas",
    component: () => import("/app/pages/pim/Mentor/Elearning/component/DiskusiTugas.vue")
  },
  {
    name: "pim-Mentor-Elearning-component-SubPenilaian",
    path: "/pim/Mentor/Elearning/component/SubPenilaian",
    component: () => import("/app/pages/pim/Mentor/Elearning/component/SubPenilaian.vue")
  },
  {
    name: "pim-Mentor-Elearning-KelompokVisitasiAgenda",
    path: "/pim/Mentor/Elearning/KelompokVisitasiAgenda",
    meta: KelompokVisitasiAgendaAdVvHe1lpPGggOBLnvk_45kLfBiyIzAxYumJqgIWQrdmMMeta || {},
    component: () => import("/app/pages/pim/Mentor/Elearning/KelompokVisitasiAgenda.vue")
  },
  {
    name: "pim-Penguji-Elearning-KelompokAksiPerubahan",
    path: "/pim/Penguji/Elearning/KelompokAksiPerubahan",
    meta: KelompokAksiPerubahantD_45JpYiIJB_5yzCbliQKhwdXyQhbzyKTWHAaMgUOKpsMeta || {},
    component: () => import("/app/pages/pim/Penguji/Elearning/KelompokAksiPerubahan.vue")
  },
  {
    name: "pim-Penguji-Elearning-KelompokStudyLapangan",
    path: "/pim/Penguji/Elearning/KelompokStudyLapangan",
    meta: KelompokStudyLapanganL590ety_45cBmp81H3EcYKc3YhVFiW0NLiW0a83GD6QdIMeta || {},
    component: () => import("/app/pages/pim/Penguji/Elearning/KelompokStudyLapangan.vue")
  },
  {
    name: "pim-Peserta-Elearning-AgendaKelas-TatapMaya",
    path: "/pim/Peserta/Elearning/AgendaKelas/TatapMaya",
    component: () => import("/app/pages/pim/Peserta/Elearning/AgendaKelas/TatapMaya.vue")
  },
  {
    name: "pim-Pembimbing-Elearning-KelompokPolicyPaper",
    path: "/pim/Pembimbing/Elearning/KelompokPolicyPaper",
    meta: KelompokPolicyPaperajRMPSfGqJrFE7EBn0HufN4VfsBe_45KbeYQubElG0vp0Meta || {},
    component: () => import("/app/pages/pim/Pembimbing/Elearning/KelompokPolicyPaper.vue")
  },
  {
    name: "pim-Penguji-Elearning-component-DiskusiTugas",
    path: "/pim/Penguji/Elearning/component/DiskusiTugas",
    component: () => import("/app/pages/pim/Penguji/Elearning/component/DiskusiTugas.vue")
  },
  {
    name: "pim-Penguji-Elearning-component-SubPenilaian",
    path: "/pim/Penguji/Elearning/component/SubPenilaian",
    component: () => import("/app/pages/pim/Penguji/Elearning/component/SubPenilaian.vue")
  },
  {
    name: "pim-Penguji-Elearning-KelompokVisitasiAgenda",
    path: "/pim/Penguji/Elearning/KelompokVisitasiAgenda",
    meta: KelompokVisitasiAgendaeUTzHNt9FrUFXOfwYy0Hox7GrOSZQrR_45p8Q2XD6PkhsMeta || {},
    component: () => import("/app/pages/pim/Penguji/Elearning/KelompokVisitasiAgenda.vue")
  },
  {
    name: "pim-Peserta-Elearning-component-DiskusiTugas",
    path: "/pim/Peserta/Elearning/component/DiskusiTugas",
    component: () => import("/app/pages/pim/Peserta/Elearning/component/DiskusiTugas.vue")
  },
  {
    name: "pembelajaran-wajib-swajar-type-jurnal",
    path: "/pembelajaran-wajib/swajar-:type()/jurnal",
    meta: { ...(indexHsYqfgZyxkCg3XGGiIGmm7qpbarX5a2Dtlo6NhWEUWsMeta || {}), ...{"middleware":["belajar-wajib","swajar"]} },
    component: () => import("/app/pages/pembelajaran-wajib/swajar-[type]/jurnal/index.vue")
  },
  {
    name: "pembelajaran-wajib-terjadwal-proyek-perubahan",
    path: "/pembelajaran-wajib/terjadwal/proyek-perubahan",
    meta: { ...(proyek_45perubahanrMawSrovacr9cltS04tQkLfAcOWYsJmnTkKz_JbAgfEMeta || {}), ...{"middleware":["belajar-wajib"]} },
    component: () => import("/app/pages/pembelajaran-wajib/terjadwal/proyek-perubahan.vue")
  },
  {
    name: "pim-role-Pelatihan-id-TugasMateriIndividu",
    path: "/pim/:role()/Pelatihan/:id()/TugasMateriIndividu",
    meta: TugasMateriIndividuRicGSDqH_K8_a7JBSk9ne_NyY4xHGU9b5UU238qCxrcMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/TugasMateriIndividu.vue")
  },
  {
    name: "pim-Mentor-Elearning-component-DetailKelompok",
    path: "/pim/Mentor/Elearning/component/DetailKelompok",
    component: () => import("/app/pages/pim/Mentor/Elearning/component/DetailKelompok.vue")
  },
  {
    name: "pim-Pengajar-Elearning-component-DataKelompok",
    path: "/pim/Pengajar/Elearning/component/DataKelompok",
    component: () => import("/app/pages/pim/Pengajar/Elearning/component/DataKelompok.vue")
  },
  {
    name: "pim-Penguji-Elearning-component-AturPenilaian",
    path: "/pim/Penguji/Elearning/component/AturPenilaian",
    component: () => import("/app/pages/pim/Penguji/Elearning/component/AturPenilaian.vue")
  },
  {
    name: "pembelajaran-wajib-swajar-type-microlearning",
    path: "/pembelajaran-wajib/swajar-:type()/microlearning",
    meta: { ...(microlearningePeDllffmWAP99X96qQTbdCkjE4s5nZU86Baz6dkQy4Meta || {}), ...{"middleware":["belajar-wajib","swajar"]} },
    component: () => import("/app/pages/pembelajaran-wajib/swajar-[type]/microlearning.vue")
  },
  {
    name: "pembelajaran-wajib-terjadwal-evaluasi-akademik",
    path: "/pembelajaran-wajib/terjadwal/evaluasi-akademik",
    meta: { ...(evaluasi_45akademikAjJv2qW_45jxLVOv8l2bx95Gppd9FzPNihRJT3Di1P6lsMeta || {}), ...{"middleware":["belajar-wajib"]} },
    component: () => import("/app/pages/pembelajaran-wajib/terjadwal/evaluasi-akademik.vue")
  },
  {
    name: "pim-role-Pelatihan-id-VisitasiKepemimpinan",
    path: "/pim/:role()/Pelatihan/:id()/VisitasiKepemimpinan",
    meta: VisitasiKepemimpinan_45WuYP517X0bcu22ix5AhuxHXj97yXLGIw5Q_wkjYMJcMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/VisitasiKepemimpinan.vue")
  },
  {
    name: "pim-Pembimbing-Elearning-component-ChatPeserta",
    path: "/pim/Pembimbing/Elearning/component/ChatPeserta",
    component: () => import("/app/pages/pim/Pembimbing/Elearning/component/ChatPeserta.vue")
  },
  {
    name: "pim-Pembimbing-Elearning-KelompokAksiPerubahan",
    path: "/pim/Pembimbing/Elearning/KelompokAksiPerubahan",
    meta: KelompokAksiPerubahanRdMgi6thw6d8X53qOgabUrPBoLxd6sOmHyqZKEfRMM8Meta || {},
    component: () => import("/app/pages/pim/Pembimbing/Elearning/KelompokAksiPerubahan.vue")
  },
  {
    name: "pim-Pembimbing-Elearning-KelompokStudyLapangan",
    path: "/pim/Pembimbing/Elearning/KelompokStudyLapangan",
    meta: KelompokStudyLapangane2fwlJ5vyfyUo42INfgKy7J_YP3kpxfPFxQpd0_451dtEMeta || {},
    component: () => import("/app/pages/pim/Pembimbing/Elearning/KelompokStudyLapangan.vue")
  },
  {
    name: "pim-Pengajar-Elearning-component-AturPenilaian",
    path: "/pim/Pengajar/Elearning/component/AturPenilaian",
    component: () => import("/app/pages/pim/Pengajar/Elearning/component/AturPenilaian.vue")
  },
  {
    name: "pim-Penguji-Elearning-component-ChatPembimbing",
    path: "/pim/Penguji/Elearning/component/ChatPembimbing",
    component: () => import("/app/pages/pim/Penguji/Elearning/component/ChatPembimbing.vue")
  },
  {
    name: "pim-Penguji-Elearning-component-DetailKelompok",
    path: "/pim/Penguji/Elearning/component/DetailKelompok",
    component: () => import("/app/pages/pim/Penguji/Elearning/component/DetailKelompok.vue")
  },
  {
    name: "pim-Peserta-Elearning-component-ChatPembimbing",
    path: "/pim/Peserta/Elearning/component/ChatPembimbing",
    component: () => import("/app/pages/pim/Peserta/Elearning/component/ChatPembimbing.vue")
  },
  {
    name: "pim-Peserta-Elearning-component-DetailKelompok",
    path: "/pim/Peserta/Elearning/component/DetailKelompok",
    component: () => import("/app/pages/pim/Peserta/Elearning/component/DetailKelompok.vue")
  },
  {
    name: "revamp-portal-pembelajaran-swajar-type",
    path: "/revamp/portal-pembelajaran/swajar-:type()",
    meta: { ...(indexKnpMZo9cWEzrAFTh7ftTVpoWTCk3FTzCfH9IP6RUO8IMeta || {}), ...{"middleware":["auth","user-data","portal-pembelajaran","swajar"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/swajar-[type]/index.vue")
  },
  {
    name: "pim-Mentor-Elearning-component-TugasPolicyPaper",
    path: "/pim/Mentor/Elearning/component/TugasPolicyPaper",
    meta: TugasPolicyPaperKG_45cwlfbYdAgFcYZPP_45PRnxjw_BsRpEnl3UL17XRz2AMeta || {},
    component: () => import("/app/pages/pim/Mentor/Elearning/component/TugasPolicyPaper.vue")
  },
  {
    name: "pim-Pembimbing-Elearning-component-DiskusiTugas",
    path: "/pim/Pembimbing/Elearning/component/DiskusiTugas",
    component: () => import("/app/pages/pim/Pembimbing/Elearning/component/DiskusiTugas.vue")
  },
  {
    name: "pim-Pembimbing-Elearning-component-SubPenilaian",
    path: "/pim/Pembimbing/Elearning/component/SubPenilaian",
    component: () => import("/app/pages/pim/Pembimbing/Elearning/component/SubPenilaian.vue")
  },
  {
    name: "pim-Pembimbing-Elearning-KelompokVisitasiAgenda",
    path: "/pim/Pembimbing/Elearning/KelompokVisitasiAgenda",
    meta: KelompokVisitasiAgendakAtZbEIZk56bKza_4tMxtJ5tKIavze_45idsGTIJZK9acMeta || {},
    component: () => import("/app/pages/pim/Pembimbing/Elearning/KelompokVisitasiAgenda.vue")
  },
  {
    name: "pim-Pengajar-Elearning-component-TugasElearning",
    path: "/pim/Pengajar/Elearning/component/TugasElearning",
    meta: TugasElearningGrkXtcoSIwd_nOdk_4589ntp0uzdBBdDhjQ8W_Ac8CD_45YMeta || {},
    component: () => import("/app/pages/pim/Pengajar/Elearning/component/TugasElearning.vue")
  },
  {
    name: "pim-Peserta-Elearning-AgendaKelas-TugasIndividu",
    path: "/pim/Peserta/Elearning/AgendaKelas/TugasIndividu",
    component: () => import("/app/pages/pim/Peserta/Elearning/AgendaKelas/TugasIndividu.vue")
  },
  {
    name: "pim-Peserta-Elearning-AgendaKelas-TugasKelompok",
    path: "/pim/Peserta/Elearning/AgendaKelas/TugasKelompok",
    component: () => import("/app/pages/pim/Peserta/Elearning/AgendaKelas/TugasKelompok.vue")
  },
  {
    name: "revamp-pembelajaran-teknis-dan-fungsional",
    path: "/revamp/pembelajaran-teknis-dan-fungsional",
    meta: indexDPMaA56siGShSiEqtxxMJjJib2MFyAY5yPef08Nm_SkMeta || {},
    component: () => import("/app/pages/revamp/pembelajaran-teknis-dan-fungsional/index.vue")
  },
  {
    name: "revamp-portal-pembelajaran-swajar-type-slug",
    path: "/revamp/portal-pembelajaran/swajar-:type()/:slug()",
    meta: { ...(_91slug_93RCw5avyslNGm4vgS9co95puiHWKFDVEZPQI_fInbJx0Meta || {}), ...{"middleware":["auth","user-data","portal-pembelajaran","swajar"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/swajar-[type]/[slug].vue")
  },
  {
    name: "revamp-portal-pembelajaran-swajar-type-jurnal",
    path: "/revamp/portal-pembelajaran/swajar-:type()/jurnal",
    meta: { ...(jurnaleq0TQ4rKVGyGNd8dFOZJ_454vzKNIO9u_45WwzMNWCqu2i8Meta || {}), ...{"middleware":["auth","user-data","portal-pembelajaran","swajar"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/swajar-[type]/jurnal.vue")
  },
  {
    name: "revamp-portal-pembelajaran-swajar-type-profil",
    path: "/revamp/portal-pembelajaran/swajar-:type()/profil",
    meta: { ...(profilFPZV34lFo3o_45cN7eWZ7Mo9QWgtlpRBs2wbx9_45CHv3JIMeta || {}), ...{"middleware":["belajar-wajib","swajar"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/swajar-[type]/profil.vue")
  },
  {
    name: "revamp-portal-pembelajaran-terjadwal-kuis",
    path: "/revamp/portal-pembelajaran/terjadwal/kuis",
    meta: { ...(index_45HQjPTJlQVM189OtL1T3pVbK6Lb3wl_nws8g9vmlyNcMeta || {}), ...{"middleware":["auth","user-data","portal-pembelajaran"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/terjadwal/kuis/index.vue")
  },
  {
    name: "pembelajaran-teknis-dan-fungsional-status-usulan",
    path: "/pembelajaran-teknis-dan-fungsional/status-usulan",
    meta: status_45usulanTrEPU_vNN6_vuV6NzDcQXeOOIGDYEfRCfhg2_jlTN1MMeta || {},
    component: () => import("/app/pages/pembelajaran-teknis-dan-fungsional/status-usulan.vue")
  },
  {
    name: "pim-Penguji-Elearning-component-TugasPolicyPaper",
    path: "/pim/Penguji/Elearning/component/TugasPolicyPaper",
    meta: TugasPolicyPaper_RGr8TMOZEkkQ3wFpQEVLqbt_SaaQ0qlGXP9MosTYnoMeta || {},
    component: () => import("/app/pages/pim/Penguji/Elearning/component/TugasPolicyPaper.vue")
  },
  {
    name: "pim-Peserta-Data-MasterDataAdministrator-DataPIC",
    path: "/pim/Peserta/Data/MasterDataAdministrator/DataPIC",
    meta: DataPIC6bTlymmh8Ht2MUq9tLw3CuKLzqsjrSkPDryzSsWfpOsMeta || {},
    component: () => import("/app/pages/pim/Peserta/Data/MasterDataAdministrator/DataPIC.vue")
  },
  {
    name: "pim-Peserta-Elearning-AgendaKelas-DetailLearning",
    path: "/pim/Peserta/Elearning/AgendaKelas/DetailLearning",
    meta: DetailLearningObKsenUTroVhunS5_O4sYZDZDMFj9EVfxGssKdFEo7wMeta || {},
    component: () => import("/app/pages/pim/Peserta/Elearning/AgendaKelas/DetailLearning.vue")
  },
  {
    name: "revamp-pembelajaran-teknis-dan-fungsional-detail",
    path: "/revamp/pembelajaran-teknis-dan-fungsional/detail",
    meta: detailI7DSV5NNtJi8kWudlUer0INNtwnFVLMsKMT4R6faRgQMeta || {},
    component: () => import("/app/pages/revamp/pembelajaran-teknis-dan-fungsional/detail.vue")
  },
  {
    name: "revamp-portal-pembelajaran-terjadwal-kuis-slug",
    path: "/revamp/portal-pembelajaran/terjadwal/kuis/:slug()",
    meta: { ...(_91slug_93y6bfZoggxCtE8_453InozhhqTDBARTAjj__0YkQ9SNIBEMeta || {}), ...{"middleware":["auth","user-data","portal-pembelajaran"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/terjadwal/kuis/[slug].vue")
  },
  {
    name: "pembelajaran-wajib-terintegrasi-evaluasi-akademik",
    path: "/pembelajaran-wajib/terintegrasi/evaluasi-akademik",
    meta: { ...(evaluasi_45akademikNIJlsh9NG2K4Fu9khRcGzfRzHHOS0dybv7nmFo5Ksq0Meta || {}), ...{"middleware":["belajar-wajib"]} },
    component: () => import("/app/pages/pembelajaran-wajib/terintegrasi/evaluasi-akademik.vue")
  },
  {
    name: "pim-Mentor-Elearning-component-TugasAksiPerubahan",
    path: "/pim/Mentor/Elearning/component/TugasAksiPerubahan",
    meta: TugasAksiPerubahanSOH1MgwhKrNNSXOHw5y2oUwYhdIoQMh0Gn6WFRJ_45gY0Meta || {},
    component: () => import("/app/pages/pim/Mentor/Elearning/component/TugasAksiPerubahan.vue")
  },
  {
    name: "pim-Mentor-Elearning-component-TugasStudyLapangan",
    path: "/pim/Mentor/Elearning/component/TugasStudyLapangan",
    meta: TugasStudyLapangan_0nGreldI1lKr_45x9mOQmEZ1n20AfHYAWoJDpnoTTeKUMeta || {},
    component: () => import("/app/pages/pim/Mentor/Elearning/component/TugasStudyLapangan.vue")
  },
  {
    name: "pim-Mentor-Elearning-KelompokVisitasiKepemimpinan",
    path: "/pim/Mentor/Elearning/KelompokVisitasiKepemimpinan",
    meta: KelompokVisitasiKepemimpinandjB6MMuqfeTkKy9Aea_45MUUfkGSR_C8SAWdoBg_IRC3MMeta || {},
    component: () => import("/app/pages/pim/Mentor/Elearning/KelompokVisitasiKepemimpinan.vue")
  },
  {
    name: "pim-Pembimbing-Elearning-component-DetailKelompok",
    path: "/pim/Pembimbing/Elearning/component/DetailKelompok",
    component: () => import("/app/pages/pim/Pembimbing/Elearning/component/DetailKelompok.vue")
  },
  {
    name: "revamp-portal-pembelajaran-orientasi-type",
    path: "/revamp/portal-pembelajaran/orientasi-:type()",
    meta: { ...(indexxrsmtRlDZpJMuWzVN7qSSu2oYt50mJfa7F1mpZd1xnIMeta || {}), ...{"middleware":["auth","user-data","portal-pembelajaran","orientasi-pppk"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/orientasi-[type]/index.vue")
  },
  {
    name: "pim-Mentor-Elearning-component-TugasVisitasiAgenda",
    path: "/pim/Mentor/Elearning/component/TugasVisitasiAgenda",
    meta: TugasVisitasiAgendacbxWPf5cpMAES00k1U73RXEH_sMZB18f6ueszaLSt_MMeta || {},
    component: () => import("/app/pages/pim/Mentor/Elearning/component/TugasVisitasiAgenda.vue")
  },
  {
    name: "pim-Penguji-Elearning-component-TugasAksiPerubahan",
    path: "/pim/Penguji/Elearning/component/TugasAksiPerubahan",
    meta: TugasAksiPerubahanz3hTRPYbm7G8twcFsx_45tJrAjU50ZqaA_sUw_45VSjm_45qgMeta || {},
    component: () => import("/app/pages/pim/Penguji/Elearning/component/TugasAksiPerubahan.vue")
  },
  {
    name: "pim-Penguji-Elearning-component-TugasStudyLapangan",
    path: "/pim/Penguji/Elearning/component/TugasStudyLapangan",
    meta: TugasStudyLapangan6uEANzDRXg6ViPlvURVQqpVGeV7IB4ObrHtV4Gy4cBoMeta || {},
    component: () => import("/app/pages/pim/Penguji/Elearning/component/TugasStudyLapangan.vue")
  },
  {
    name: "pim-Penguji-Elearning-KelompokVisitasiKepemimpinan",
    path: "/pim/Penguji/Elearning/KelompokVisitasiKepemimpinan",
    meta: KelompokVisitasiKepemimpinan1dkQE7xer8mv2Lqw2a9LJMTJVCiUZAQGQQ8y26wgWvQMeta || {},
    component: () => import("/app/pages/pim/Penguji/Elearning/KelompokVisitasiKepemimpinan.vue")
  },
  {
    name: "revamp-pembelajaran-teknis-dan-fungsional-formulir",
    path: "/revamp/pembelajaran-teknis-dan-fungsional/formulir",
    meta: formulir4KYp8k225eFhTwGdZue9lmyW3tqjO_456n3n_mQLm7spYMeta || {},
    component: () => import("/app/pages/revamp/pembelajaran-teknis-dan-fungsional/formulir.vue")
  },
  {
    name: "pim-role-Pelatihan-id-componentsetting-LinkForm",
    path: "/pim/:role()/Pelatihan/:id()/componentsetting/LinkForm",
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/LinkForm.vue")
  },
  {
    name: "pim-role-Pelatihan-id-componentsetting-TaskForm",
    path: "/pim/:role()/Pelatihan/:id()/componentsetting/TaskForm",
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/TaskForm.vue")
  },
  {
    name: "pim-Pembimbing-Elearning-component-TugasPolicyPaper",
    path: "/pim/Pembimbing/Elearning/component/TugasPolicyPaper",
    meta: TugasPolicyPaperOPcvgelpQw8UVI8cc3rmC6AdsepqzuKrc6hb9igHl70Meta || {},
    component: () => import("/app/pages/pim/Pembimbing/Elearning/component/TugasPolicyPaper.vue")
  },
  {
    name: "pim-Penguji-Elearning-component-TugasVisitasiAgenda",
    path: "/pim/Penguji/Elearning/component/TugasVisitasiAgenda",
    meta: TugasVisitasiAgendaVZxPxj9oBYCGGPKiJN9aevFCbe0ULiWuKVko7FTWv8sMeta || {},
    component: () => import("/app/pages/pim/Penguji/Elearning/component/TugasVisitasiAgenda.vue")
  },
  {
    name: "revamp-portal-pembelajaran-terjadwal-evaluasi-essay",
    path: "/revamp/portal-pembelajaran/terjadwal/evaluasi-essay",
    meta: { ...(evaluasi_45essayAvEfX5THrMTAeoLfQAmU5lvLva9zqLR9N2g0KcwQIC8Meta || {}), ...{"middleware":["auth","user-data","portal-pembelajaran"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/terjadwal/evaluasi-essay.vue")
  },
  {
    name: "pim-role-Pelatihan-id-componentsetting-FileUpload",
    path: "/pim/:role()/Pelatihan/:id()/componentsetting/FileUpload",
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/FileUpload.vue")
  },
  {
    name: "pim-Pembimbing-Elearning-component-TugasAksiPerubahan",
    path: "/pim/Pembimbing/Elearning/component/TugasAksiPerubahan",
    meta: TugasAksiPerubahanAyLa8Vl8PPTNlsZohfMDp9ottBsUcX80I0Gd5IEDFcsMeta || {},
    component: () => import("/app/pages/pim/Pembimbing/Elearning/component/TugasAksiPerubahan.vue")
  },
  {
    name: "pim-Pembimbing-Elearning-component-TugasStudyLapangan",
    path: "/pim/Pembimbing/Elearning/component/TugasStudyLapangan",
    meta: TugasStudyLapanganvF7Qzq_45weEtzHlaGwl0Qhf_g0p6R_fBKxQs19t0vg9kMeta || {},
    component: () => import("/app/pages/pim/Pembimbing/Elearning/component/TugasStudyLapangan.vue")
  },
  {
    name: "pim-Pembimbing-Elearning-KelompokVisitasiKepemimpinan",
    path: "/pim/Pembimbing/Elearning/KelompokVisitasiKepemimpinan",
    meta: KelompokVisitasiKepemimpinan_H8VGETT_45k_77Lg2vNEk4vuhlFJ3mLzi8WuxWJtpoDQMeta || {},
    component: () => import("/app/pages/pim/Pembimbing/Elearning/KelompokVisitasiKepemimpinan.vue")
  },
  {
    name: "pim-Peserta-Elearning-AgendaKelas-TugasMateriIndividu",
    path: "/pim/Peserta/Elearning/AgendaKelas/TugasMateriIndividu",
    component: () => import("/app/pages/pim/Peserta/Elearning/AgendaKelas/TugasMateriIndividu.vue")
  },
  {
    name: "revamp-portal-pembelajaran-pembelajaran-mandiri",
    path: "/revamp/portal-pembelajaran/pembelajaran-mandiri",
    meta: { ...(indexGVz0xzFvNhqB7OvoycSc4PVab6g4vOHT4CR1fve_45J24Meta || {}), ...{"middleware":["auth","user-data","belajar-wajib"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/pembelajaran-mandiri/index.vue")
  },
  {
    name: "revamp-portal-pembelajaran-terjadwal-proyek-perubahan",
    path: "/revamp/portal-pembelajaran/terjadwal/proyek-perubahan",
    meta: { ...(proyek_45perubahancHBBMQ7118N5gDGzYFaBjhblQqiucjwrZm4FkObyGY0Meta || {}), ...{"middleware":["auth","user-data","portal-pembelajaran"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/terjadwal/proyek-perubahan.vue")
  },
  {
    name: "pim-Mentor-Elearning-component-DiskusiTugasPolicyPaper",
    path: "/pim/Mentor/Elearning/component/DiskusiTugasPolicyPaper",
    component: () => import("/app/pages/pim/Mentor/Elearning/component/DiskusiTugasPolicyPaper.vue")
  },
  {
    name: "pim-Pembimbing-Elearning-component-TugasVisitasiAgenda",
    path: "/pim/Pembimbing/Elearning/component/TugasVisitasiAgenda",
    meta: TugasVisitasiAgendatHEqAC3zz5fr19AgbtueOUK5aSgVZPlOC0z1OQxR3_0Meta || {},
    component: () => import("/app/pages/pim/Pembimbing/Elearning/component/TugasVisitasiAgenda.vue")
  },
  {
    name: "pim-Pengajar-Elearning-component-TugasEvaluasiSubtansi",
    path: "/pim/Pengajar/Elearning/component/TugasEvaluasiSubtansi",
    meta: TugasEvaluasiSubtansieTJ9d4mPY4m1f5kV3MbJ0fHNUNtLUc2WlNv6qcDoq68Meta || {},
    component: () => import("/app/pages/pim/Pengajar/Elearning/component/TugasEvaluasiSubtansi.vue")
  },
  {
    name: "portal-pembelajaran-orientasi-type-agenda-id",
    path: "/portal-pembelajaran/orientasi-:type()/agenda-:id()",
    meta: indexENl2XCMTh_45dUaZh2_45n1izGYLij1KYIbLhvCnaWMdC5YMeta || {},
    component: () => import("/app/pages/portal-pembelajaran/orientasi-[type]/agenda-[id]/index.vue")
  },
  {
    name: "revamp-portal-pembelajaran-terjadwal-evaluasi-akademik",
    path: "/revamp/portal-pembelajaran/terjadwal/evaluasi-akademik",
    meta: { ...(evaluasi_45akademikzGg9imiXsv_LIacAex0l0_moYwH0WmNb30teK7fBy8AMeta || {}), ...{"middleware":["auth","user-data","portal-pembelajaran"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/terjadwal/evaluasi-akademik.vue")
  },
  {
    name: "pim-role-Pelatihan-id-componentsetting-LogPelatihan",
    path: "/pim/:role()/Pelatihan/:id()/componentsetting/LogPelatihan",
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/LogPelatihan.vue")
  },
  {
    name: "pim-Penguji-Elearning-component-DiskusiTugasPolicyPaper",
    path: "/pim/Penguji/Elearning/component/DiskusiTugasPolicyPaper",
    component: () => import("/app/pages/pim/Penguji/Elearning/component/DiskusiTugasPolicyPaper.vue")
  },
  {
    name: "pim-Peserta-Elearning-component-DiskusiTugasPolicyPaper",
    path: "/pim/Peserta/Elearning/component/DiskusiTugasPolicyPaper",
    component: () => import("/app/pages/pim/Peserta/Elearning/component/DiskusiTugasPolicyPaper.vue")
  },
  {
    name: "portal-pembelajaran-orientasi-type-agenda-id-slug",
    path: "/portal-pembelajaran/orientasi-:type()/agenda-:id()/:slug()",
    meta: _91slug_93NCIPHsZn72Lj1i2u9kkg0dbQo45VLy_st3ZUQs8g9RIMeta || {},
    component: () => import("/app/pages/portal-pembelajaran/orientasi-[type]/agenda-[id]/[slug].vue")
  },
  {
    name: "revamp-pembelajaran-teknis-dan-fungsional-status-usulan",
    path: "/revamp/pembelajaran-teknis-dan-fungsional/status-usulan",
    meta: status_45usulandYrDcwHXTfzZJd5yA0UeLiM9BqgXhZkp3bsKbZ_45zlREMeta || {},
    component: () => import("/app/pages/revamp/pembelajaran-teknis-dan-fungsional/status-usulan.vue")
  },
  {
    name: "pim-role-Pelatihan-id-componentsetting-AturPenilaian",
    path: "/pim/:role()/Pelatihan/:id()/componentsetting/AturPenilaian",
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/AturPenilaian.vue")
  },
  {
    name: "pim-Mentor-Elearning-component-DetailKelompokPolicyBrief",
    path: "/pim/Mentor/Elearning/component/DetailKelompokPolicyBrief",
    component: () => import("/app/pages/pim/Mentor/Elearning/component/DetailKelompokPolicyBrief.vue")
  },
  {
    name: "pim-Mentor-Elearning-component-DiskusiTugasStudyLapangan",
    path: "/pim/Mentor/Elearning/component/DiskusiTugasStudyLapangan",
    component: () => import("/app/pages/pim/Mentor/Elearning/component/DiskusiTugasStudyLapangan.vue")
  },
  {
    name: "pim-Mentor-Elearning-component-TugasVisitasiKepemimpinan",
    path: "/pim/Mentor/Elearning/component/TugasVisitasiKepemimpinan",
    meta: TugasVisitasiKepemimpinanhOopVcy_45Qi59u1D4hRb_r1To6NgTQ1RQtSIhAXSR4oQMeta || {},
    component: () => import("/app/pages/pim/Mentor/Elearning/component/TugasVisitasiKepemimpinan.vue")
  },
  {
    name: "pim-Penguji-Elearning-component-AturPenilaianPolicyPaper",
    path: "/pim/Penguji/Elearning/component/AturPenilaianPolicyPaper",
    component: () => import("/app/pages/pim/Penguji/Elearning/component/AturPenilaianPolicyPaper.vue")
  },
  {
    name: "revamp-portal-pembelajaran-terjadwal-self-learning",
    path: "/revamp/portal-pembelajaran/terjadwal/self-learning",
    meta: { ...(indexrsjmihRoymWQ0_453rsaARxf3q_45hD_45jVdwvqMoI_Wkhn4Meta || {}), ...{"middleware":["auth","user-data","portal-pembelajaran"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/terjadwal/self-learning/index.vue")
  },
  {
    name: "pim-role-Pelatihan-id-componentsetting-UploadTaskFile",
    path: "/pim/:role()/Pelatihan/:id()/componentsetting/UploadTaskFile",
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/UploadTaskFile.vue")
  },
  {
    name: "pim-Mentor-Elearning-component-DiskusiTugasVisitasiAgenda",
    path: "/pim/Mentor/Elearning/component/DiskusiTugasVisitasiAgenda",
    component: () => import("/app/pages/pim/Mentor/Elearning/component/DiskusiTugasVisitasiAgenda.vue")
  },
  {
    name: "pim-Penguji-Elearning-component-DetailKelompokPolicyBrief",
    path: "/pim/Penguji/Elearning/component/DetailKelompokPolicyBrief",
    component: () => import("/app/pages/pim/Penguji/Elearning/component/DetailKelompokPolicyBrief.vue")
  },
  {
    name: "pim-Penguji-Elearning-component-DiskusiTugasStudyLapangan",
    path: "/pim/Penguji/Elearning/component/DiskusiTugasStudyLapangan",
    component: () => import("/app/pages/pim/Penguji/Elearning/component/DiskusiTugasStudyLapangan.vue")
  },
  {
    name: "pim-Penguji-Elearning-component-SubPenilaianAksiPerubahan",
    path: "/pim/Penguji/Elearning/component/SubPenilaianAksiPerubahan",
    component: () => import("/app/pages/pim/Penguji/Elearning/component/SubPenilaianAksiPerubahan.vue")
  },
  {
    name: "pim-Penguji-Elearning-component-TugasVisitasiKepemimpinan",
    path: "/pim/Penguji/Elearning/component/TugasVisitasiKepemimpinan",
    meta: TugasVisitasiKepemimpinanwXeR74WXbJuSOoYQvtyXKYVizI9SEtw9asIL0ig_G6cMeta || {},
    component: () => import("/app/pages/pim/Penguji/Elearning/component/TugasVisitasiKepemimpinan.vue")
  },
  {
    name: "pim-Peserta-Elearning-component-DetailKelompokPolicyBrief",
    path: "/pim/Peserta/Elearning/component/DetailKelompokPolicyBrief",
    component: () => import("/app/pages/pim/Peserta/Elearning/component/DetailKelompokPolicyBrief.vue")
  },
  {
    name: "pim-Peserta-Elearning-component-DiskusiTugasStudyLapangan",
    path: "/pim/Peserta/Elearning/component/DiskusiTugasStudyLapangan",
    component: () => import("/app/pages/pim/Peserta/Elearning/component/DiskusiTugasStudyLapangan.vue")
  },
  {
    name: "revamp-portal-pembelajaran-terjadwal-self-learning-slug",
    path: "/revamp/portal-pembelajaran/terjadwal/self-learning/:slug()",
    meta: { ...(_91slug_932mXZAN_CQjVZovtKZ5ut0Qt8mYl4PlB8PJwNjjZwd0YMeta || {}), ...{"middleware":["auth","user-data","portal-pembelajaran"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/terjadwal/self-learning/[slug].vue")
  },
  {
    name: "pim-Mentor-Elearning-component-DetailKelompokStudyLapangan",
    path: "/pim/Mentor/Elearning/component/DetailKelompokStudyLapangan",
    component: () => import("/app/pages/pim/Mentor/Elearning/component/DetailKelompokStudyLapangan.vue")
  },
  {
    name: "pim-Pembimbing-Elearning-component-DiskusiTugasPolicyPaper",
    path: "/pim/Pembimbing/Elearning/component/DiskusiTugasPolicyPaper",
    component: () => import("/app/pages/pim/Pembimbing/Elearning/component/DiskusiTugasPolicyPaper.vue")
  },
  {
    name: "pim-Pengajar-Elearning-component-SubPenilaianAksiPerubahan",
    path: "/pim/Pengajar/Elearning/component/SubPenilaianAksiPerubahan",
    component: () => import("/app/pages/pim/Pengajar/Elearning/component/SubPenilaianAksiPerubahan.vue")
  },
  {
    name: "pim-Penguji-Elearning-component-AturPenilaianStudyLapangan",
    path: "/pim/Penguji/Elearning/component/AturPenilaianStudyLapangan",
    component: () => import("/app/pages/pim/Penguji/Elearning/component/AturPenilaianStudyLapangan.vue")
  },
  {
    name: "pim-Penguji-Elearning-component-DiskusiTugasVisitasiAgenda",
    path: "/pim/Penguji/Elearning/component/DiskusiTugasVisitasiAgenda",
    component: () => import("/app/pages/pim/Penguji/Elearning/component/DiskusiTugasVisitasiAgenda.vue")
  },
  {
    name: "pim-Peserta-Elearning-component-DiskusiTugasVisitasiAgenda",
    path: "/pim/Peserta/Elearning/component/DiskusiTugasVisitasiAgenda",
    component: () => import("/app/pages/pim/Peserta/Elearning/component/DiskusiTugasVisitasiAgenda.vue")
  },
  {
    name: "portal-pembelajaran-orientasi-type-agenda-id-rangkuman",
    path: "/portal-pembelajaran/orientasi-:type()/agenda-:id()/rangkuman",
    meta: rangkumanESETOv00wooA2_G5Lw72lMH_rZoln9Rvm_45Nk3izmHuMMeta || {},
    component: () => import("/app/pages/portal-pembelajaran/orientasi-[type]/agenda-[id]/rangkuman.vue")
  },
  {
    name: "revamp-portal-pembelajaran-swajar-type-kurikulum-2",
    path: "/revamp/portal-pembelajaran/swajar-:type()/kurikulum-2",
    meta: { ...(index5yke3ZelRcJJXuI603vQbO9o7GVzcDj_r_2_45PA5Hzz4Meta || {}), ...{"middleware":["auth","user-data","portal-pembelajaran","swajar"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/swajar-[type]/kurikulum-2/index.vue")
  },
  {
    name: "pim-Mentor-Elearning-component-DetailKelompokVisitasiAgenda",
    path: "/pim/Mentor/Elearning/component/DetailKelompokVisitasiAgenda",
    component: () => import("/app/pages/pim/Mentor/Elearning/component/DetailKelompokVisitasiAgenda.vue")
  },
  {
    name: "pim-Penguji-Elearning-component-AturPenilaianVisitasiAgenda",
    path: "/pim/Penguji/Elearning/component/AturPenilaianVisitasiAgenda",
    component: () => import("/app/pages/pim/Penguji/Elearning/component/AturPenilaianVisitasiAgenda.vue")
  },
  {
    name: "pim-Penguji-Elearning-component-DetailKelompokStudyLapangan",
    path: "/pim/Penguji/Elearning/component/DetailKelompokStudyLapangan",
    component: () => import("/app/pages/pim/Penguji/Elearning/component/DetailKelompokStudyLapangan.vue")
  },
  {
    name: "pim-Peserta-Elearning-component-DetailKelompokStudyLapangan",
    path: "/pim/Peserta/Elearning/component/DetailKelompokStudyLapangan",
    component: () => import("/app/pages/pim/Peserta/Elearning/component/DetailKelompokStudyLapangan.vue")
  },
  {
    name: "revamp-portal-pembelajaran-swajar-type-kurikulum-2-slug",
    path: "/revamp/portal-pembelajaran/swajar-:type()/kurikulum-2/:slug()",
    meta: { ...(_91slug_93Lzx8CghA_45qIDzYwqlomw6b_45WjhC4OdBrQKXo1vUHwccMeta || {}), ...{"middleware":["auth","user-data","portal-pembelajaran","swajar"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/swajar-[type]/kurikulum-2/[slug].vue")
  },
  {
    name: "revamp-portal-pembelajaran-swajar-type-kurikulum-2-jurnal",
    path: "/revamp/portal-pembelajaran/swajar-:type()/kurikulum-2/jurnal",
    meta: { ...(jurnalQL03UK5b1eM_45eK_45BGO9Z_45z1240T7J_InNBRevJVnIC0Meta || {}), ...{"middleware":["auth","user-data","portal-pembelajaran","swajar"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/swajar-[type]/kurikulum-2/jurnal.vue")
  },
  {
    name: "pim-Pembimbing-Elearning-component-DetailKelompokPolicyBrief",
    path: "/pim/Pembimbing/Elearning/component/DetailKelompokPolicyBrief",
    component: () => import("/app/pages/pim/Pembimbing/Elearning/component/DetailKelompokPolicyBrief.vue")
  },
  {
    name: "pim-Pembimbing-Elearning-component-DiskusiTugasStudyLapangan",
    path: "/pim/Pembimbing/Elearning/component/DiskusiTugasStudyLapangan",
    component: () => import("/app/pages/pim/Pembimbing/Elearning/component/DiskusiTugasStudyLapangan.vue")
  },
  {
    name: "pim-Pembimbing-Elearning-component-TugasVisitasiKepemimpinan",
    path: "/pim/Pembimbing/Elearning/component/TugasVisitasiKepemimpinan",
    meta: TugasVisitasiKepemimpinan2vavbtw_45EQRD9vHgGq5lOabmLRyHeCjESDUwMLYpbVcMeta || {},
    component: () => import("/app/pages/pim/Pembimbing/Elearning/component/TugasVisitasiKepemimpinan.vue")
  },
  {
    name: "pim-Penguji-Elearning-component-DetailKelompokVisitasiAgenda",
    path: "/pim/Penguji/Elearning/component/DetailKelompokVisitasiAgenda",
    component: () => import("/app/pages/pim/Penguji/Elearning/component/DetailKelompokVisitasiAgenda.vue")
  },
  {
    name: "pim-Peserta-Elearning-component-DetailKelompokVisitasiAgenda",
    path: "/pim/Peserta/Elearning/component/DetailKelompokVisitasiAgenda",
    component: () => import("/app/pages/pim/Peserta/Elearning/component/DetailKelompokVisitasiAgenda.vue")
  },
  {
    name: "revamp-portal-pembelajaran-pembelajaran-mandiri-slug",
    path: "/revamp/portal-pembelajaran/pembelajaran-mandiri/:slug()",
    meta: { ...(indexTqNR8efAAb6E31c65rcZpfg943BsUIszMTlzHjD59FMMeta || {}), ...{"middleware":["auth","user-data","belajar-wajib"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/pembelajaran-mandiri/[slug]/index.vue")
  },
  {
    name: "revamp-portal-pembelajaran-swajar-type-microlearning",
    path: "/revamp/portal-pembelajaran/swajar-:type()/microlearning",
    meta: { ...(indexVvCd3Tw5GzxjRLjofRgFWEHlOvzKaRbELkOLIMoaoW0Meta || {}), ...{"middleware":["auth","user-data","portal-pembelajaran","swajar"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/swajar-[type]/microlearning/index.vue")
  },
  {
    name: "pembelajaran-wajib-swajar-type-evaluasi-akademik-id",
    path: "/pembelajaran-wajib/swajar-:type()/evaluasi-akademik-:id()",
    meta: { ...(indexTZjaicmB_yoI8e36cstlWDCnsnGXouRyc9mJaHreZggMeta || {}), ...{"middleware":["belajar-wajib","swajar"]} },
    component: () => import("/app/pages/pembelajaran-wajib/swajar-[type]/evaluasi-akademik-[id]/index.vue")
  },
  {
    name: "pim-Pembimbing-Elearning-component-DiskusiTugasVisitasiAgenda",
    path: "/pim/Pembimbing/Elearning/component/DiskusiTugasVisitasiAgenda",
    component: () => import("/app/pages/pim/Pembimbing/Elearning/component/DiskusiTugasVisitasiAgenda.vue")
  },
  {
    name: "revamp-portal-pembelajaran-orientasi-type-agenda-id",
    path: "/revamp/portal-pembelajaran/orientasi-:type()/agenda-:id()",
    meta: index2iZgEppbZ94nDReDkptqt5XNM8Gg49LqBxw8Mg_5VnMMeta || {},
    component: () => import("/app/pages/revamp/portal-pembelajaran/orientasi-[type]/agenda-[id]/index.vue")
  },
  {
    name: "revamp-portal-pembelajaran-pembelajaran-mandiri-slug-lesson",
    path: "/revamp/portal-pembelajaran/pembelajaran-mandiri/:slug()/lesson",
    meta: { ...(lesson_45nd0wQ8XPzFlTSSazGC_45fwn9kQeLBy5uRVCx4YBOGwgMeta || {}), ...{"middleware":["auth","belajar-wajib"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/pembelajaran-mandiri/[slug]/lesson.vue")
  },
  {
    name: "revamp-portal-pembelajaran-swajar-type-microlearning-slug",
    path: "/revamp/portal-pembelajaran/swajar-:type()/microlearning/:slug()",
    meta: { ...(_91slug_93hEQmY3YYdXjJNOnv36_45c_Ds_45yeKzVgw7UbngJuvpIDwMeta || {}), ...{"middleware":["auth","user-data","portal-pembelajaran","swajar"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/swajar-[type]/microlearning/[slug].vue")
  },
  {
    name: "pim-Pembimbing-Elearning-component-DetailKelompokStudyLapangan",
    path: "/pim/Pembimbing/Elearning/component/DetailKelompokStudyLapangan",
    component: () => import("/app/pages/pim/Pembimbing/Elearning/component/DetailKelompokStudyLapangan.vue")
  },
  {
    name: "revamp-portal-pembelajaran-orientasi-type-agenda-id-slug",
    path: "/revamp/portal-pembelajaran/orientasi-:type()/agenda-:id()/:slug()",
    meta: _91slug_93KaIiciJLl9XNgQBZiVGxZG8xqJTDZ_vfe1PlLxJ2wssMeta || {},
    component: () => import("/app/pages/revamp/portal-pembelajaran/orientasi-[type]/agenda-[id]/[slug].vue")
  },
  {
    name: "pim-role-Pelatihan-id-componentsetting-StakeHolder-Alacarte",
    path: "/pim/:role()/Pelatihan/:id()/componentsetting/StakeHolder/Alacarte",
    meta: AlacartekMVj364sMPHCtuE61qI1Kcc6idtLodLJDzrwEat5_458oMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/StakeHolder/Alacarte.vue")
  },
  {
    name: "pim-Mentor-Elearning-component-DiskusiTugasVisitasiKepemimpinan",
    path: "/pim/Mentor/Elearning/component/DiskusiTugasVisitasiKepemimpinan",
    component: () => import("/app/pages/pim/Mentor/Elearning/component/DiskusiTugasVisitasiKepemimpinan.vue")
  },
  {
    name: "pim-Pembimbing-Elearning-component-DetailKelompokVisitasiAgenda",
    path: "/pim/Pembimbing/Elearning/component/DetailKelompokVisitasiAgenda",
    component: () => import("/app/pages/pim/Pembimbing/Elearning/component/DetailKelompokVisitasiAgenda.vue")
  },
  {
    name: "revamp-portal-pembelajaran-pembelajaran-mandiri-dashboard",
    path: "/revamp/portal-pembelajaran/pembelajaran-mandiri/dashboard",
    meta: { ...(indexOS_457N__SByk5A9dW2YJwULGgdCC1UXbNG0yJaJ_xIKYMeta || {}), ...{"middleware":["auth","belajar-wajib","ecosystem"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/pembelajaran-mandiri/dashboard/index.vue")
  },
  {
    name: "pim-role-Pelatihan-id-componentsetting-StakeHolder-Mandatory",
    path: "/pim/:role()/Pelatihan/:id()/componentsetting/StakeHolder/Mandatory",
    meta: Mandatory8tL6LyuyN_45otXKKADTpKN9i1aL521AFjufwrAfIKdF8Meta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/StakeHolder/Mandatory.vue")
  },
  {
    name: "pim-Penguji-Elearning-component-DiskusiTugasVisitasiKepemimpinan",
    path: "/pim/Penguji/Elearning/component/DiskusiTugasVisitasiKepemimpinan",
    component: () => import("/app/pages/pim/Penguji/Elearning/component/DiskusiTugasVisitasiKepemimpinan.vue")
  },
  {
    name: "pim-Peserta-Elearning-component-DiskusiTugasVisitasiKepemimpinan",
    path: "/pim/Peserta/Elearning/component/DiskusiTugasVisitasiKepemimpinan",
    component: () => import("/app/pages/pim/Peserta/Elearning/component/DiskusiTugasVisitasiKepemimpinan.vue")
  },
  {
    name: "revamp-portal-pembelajaran-swajar-type-evaluasi-akademik",
    path: "/revamp/portal-pembelajaran/swajar-:type()/evaluasi-akademik",
    meta: { ...(index84dB0OCYhje9mvHWuaZ8gR3E_4588WWkuYSaZ8yUGGJ0AMeta || {}), ...{"middleware":["auth","user-data","portal-pembelajaran","swajar"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/swajar-[type]/evaluasi-akademik/index.vue")
  },
  {
    name: "pim-role-Pelatihan-id-componentsetting-StakeHolder-LogAbsensi",
    path: "/pim/:role()/Pelatihan/:id()/componentsetting/StakeHolder/LogAbsensi",
    meta: LogAbsensiLH4OEbwPBsqbo8_454KTmWZGAMTAKC2idJxCRQQ_45W3nEwMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/StakeHolder/LogAbsensi.vue")
  },
  {
    name: "pim-role-Pelatihan-id-componentsetting-StakeHolder-MentorForm",
    path: "/pim/:role()/Pelatihan/:id()/componentsetting/StakeHolder/MentorForm",
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/StakeHolder/MentorForm.vue")
  },
  {
    name: "pim-Mentor-Elearning-component-DetailKelompokVisitasiKepemimpinan",
    path: "/pim/Mentor/Elearning/component/DetailKelompokVisitasiKepemimpinan",
    component: () => import("/app/pages/pim/Mentor/Elearning/component/DetailKelompokVisitasiKepemimpinan.vue")
  },
  {
    name: "pim-Penguji-Elearning-component-AturPenilaianVisitasiKepemimpinan",
    path: "/pim/Penguji/Elearning/component/AturPenilaianVisitasiKepemimpinan",
    component: () => import("/app/pages/pim/Penguji/Elearning/component/AturPenilaianVisitasiKepemimpinan.vue")
  },
  {
    name: "revamp-portal-pembelajaran-orientasi-type-agenda-id-rangkuman",
    path: "/revamp/portal-pembelajaran/orientasi-:type()/agenda-:id()/rangkuman",
    meta: rangkuman6yPBGbo4yk_6X8pqWG2d4stzEAUORRNmpFN9hBFgtcwMeta || {},
    component: () => import("/app/pages/revamp/portal-pembelajaran/orientasi-[type]/agenda-[id]/rangkuman.vue")
  },
  {
    name: "pim-role-Pelatihan-id-componentsetting-StakeHolder-PengujiForm",
    path: "/pim/:role()/Pelatihan/:id()/componentsetting/StakeHolder/PengujiForm",
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/StakeHolder/PengujiForm.vue")
  },
  {
    name: "pim-Penguji-Elearning-component-DetailKelompokVisitasiKepemimpinan",
    path: "/pim/Penguji/Elearning/component/DetailKelompokVisitasiKepemimpinan",
    component: () => import("/app/pages/pim/Penguji/Elearning/component/DetailKelompokVisitasiKepemimpinan.vue")
  },
  {
    name: "pim-Peserta-Elearning-component-DetailKelompokVisitasiKepemimpinan",
    path: "/pim/Peserta/Elearning/component/DetailKelompokVisitasiKepemimpinan",
    component: () => import("/app/pages/pim/Peserta/Elearning/component/DetailKelompokVisitasiKepemimpinan.vue")
  },
  {
    name: "pim-role-Pelatihan-id-componentsetting-StakeHolder-LogElearning",
    path: "/pim/:role()/Pelatihan/:id()/componentsetting/StakeHolder/LogElearning",
    meta: LogElearningx1T2nryqA_45eXjgtMP1GKaVPlMhofzxIfny7zCkkPMLAMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/StakeHolder/LogElearning.vue")
  },
  {
    name: "pim-role-Pelatihan-id-componentsetting-StakeHolder-PengajarForm",
    path: "/pim/:role()/Pelatihan/:id()/componentsetting/StakeHolder/PengajarForm",
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/StakeHolder/PengajarForm.vue")
  },
  {
    name: "pim-Pembimbing-Elearning-component-DiskusiTugasVisitasiKepemimpinan",
    path: "/pim/Pembimbing/Elearning/component/DiskusiTugasVisitasiKepemimpinan",
    component: () => import("/app/pages/pim/Pembimbing/Elearning/component/DiskusiTugasVisitasiKepemimpinan.vue")
  },
  {
    name: "pim-role-Pelatihan-id-componentsetting-StakeHolder-KurikulumInti",
    path: "/pim/:role()/Pelatihan/:id()/componentsetting/StakeHolder/KurikulumInti",
    meta: KurikulumIntiD3m6MRn5C0vnwU9uM7UpQf_45E3NIXOJdx4zBS_l8IrcoMeta || {},
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/StakeHolder/KurikulumInti.vue")
  },
  {
    name: "pim-role-Pelatihan-id-componentsetting-SubPenilaianAksiPerubahan",
    path: "/pim/:role()/Pelatihan/:id()/componentsetting/SubPenilaianAksiPerubahan",
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/SubPenilaianAksiPerubahan.vue")
  },
  {
    name: "pim-role-Pelatihan-id-componentsetting-StakeHolder-PembimbingForm",
    path: "/pim/:role()/Pelatihan/:id()/componentsetting/StakeHolder/PembimbingForm",
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/StakeHolder/PembimbingForm.vue")
  },
  {
    name: "pim-Pembimbing-Elearning-component-DetailKelompokVisitasiKepemimpinan",
    path: "/pim/Pembimbing/Elearning/component/DetailKelompokVisitasiKepemimpinan",
    component: () => import("/app/pages/pim/Pembimbing/Elearning/component/DetailKelompokVisitasiKepemimpinan.vue")
  },
  {
    name: "revamp-portal-pembelajaran-swajar-type-evaluasi-akademik-id",
    path: "/revamp/portal-pembelajaran/swajar-:type()/evaluasi-akademik-:id()",
    meta: { ...(indexnv1L1h_45_45XtSkER5H3IVWBjpPxB14enJe1Co7awMeO8cMeta || {}), ...{"middleware":["auth","user-data","portal-pembelajaran","swajar"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/swajar-[type]/evaluasi-akademik-[id]/index.vue")
  },
  {
    name: "pim-role-Pelatihan-id-componentsetting-StakeHolder-LogSelflearning",
    path: "/pim/:role()/Pelatihan/:id()/componentsetting/StakeHolder/LogSelflearning",
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/StakeHolder/LogSelflearning.vue")
  },
  {
    name: "pim-role-Pelatihan-id-componentsetting-AturPenilaianEvaluasiSubtansi",
    path: "/pim/:role()/Pelatihan/:id()/componentsetting/AturPenilaianEvaluasiSubtansi",
    component: () => import("/app/pages/pim/[role]/Pelatihan/[id]/componentsetting/AturPenilaianEvaluasiSubtansi.vue")
  },
  {
    name: "portal-pembelajaran-orientasi-type-agenda-id-evaluasi-akademik",
    path: "/portal-pembelajaran/orientasi-:type()/agenda-:id()/evaluasi-akademik",
    meta: indexr4orPbVgszin01_BnXupMkCQGP2E_JBeAnrdcVB5PnYMeta || {},
    component: () => import("/app/pages/portal-pembelajaran/orientasi-[type]/agenda-[id]/evaluasi-akademik/index.vue")
  },
  {
    name: "revamp-portal-pembelajaran-swajar-type-kurikulum-2-evaluasi-akademik",
    path: "/revamp/portal-pembelajaran/swajar-:type()/kurikulum-2/evaluasi-akademik",
    meta: { ...(indexJg8dGshBnluN4EeoeSju7r_mHenObpAV8wzkt4xHI_IMeta || {}), ...{"middleware":["auth","user-data","portal-pembelajaran","swajar"]} },
    component: () => import("/app/pages/revamp/portal-pembelajaran/swajar-[type]/kurikulum-2/evaluasi-akademik/index.vue")
  },
  {
    name: "revamp-portal-pembelajaran-orientasi-type-agenda-id-evaluasi-akademik",
    path: "/revamp/portal-pembelajaran/orientasi-:type()/agenda-:id()/evaluasi-akademik",
    meta: indexiw8T2lDuG3ufRJE6gUQOMLtxt6zKLaD3NlVutLWU3UkMeta || {},
    component: () => import("/app/pages/revamp/portal-pembelajaran/orientasi-[type]/agenda-[id]/evaluasi-akademik/index.vue")
  }
]